import React from 'react';
import ReactDOM from 'react-dom/client';
import {useNavigate} from 'react-router-dom';
import {ReactViewAdobe, previewFile} from 'react-adobe-embed';

import {AnimatePresence, motion } from 'framer-motion';
// import {
//   Editor,
//   Toolbar,
// EditorProvider
// } from 'react-simple-wysiwyg';
import '../assets/css/SecureMessage.scss';
import JsxMessages, { getDate } from './JsxMessages';
import { RichTextEditorComponent } from '@syncfusion/ej2-react-richtexteditor';

const latexQuote=
`
<blockquote 



class="wp-block-quote">
  <p>
    You can then apply applicable<mark
      style="background-color: rgba(0, 0, 0, 0)"
      class="has-inline-color has-pale-pink-color"
    >
      lemmas, theorems, corollaries</mark
    >
    found within the properties seen in calculus to use within your function in order to quickly simplify your function
    formed.
  </p>
  <hr class="wp-block-separator has-alpha-channel-opacity" />
  <p>For example, when f(x) so happens to be:</p>
  <div class="wp-block-katex-display-block katex-eq katex-rendered" data-katex-display="true" style="font-family:articulat-cf;">
    <span class="katex-display">
      <span class="katex">
        <span class="katex-mathml">
          <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
            <semantics>
              <mrow>
                <mrow>
                  <mtable rowspacing="0.1600em" columnalign="left" columnspacing="1em">
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <mi>f</mi>
                            <mo stretchy="false">(</mo>
                            <mi>x</mi>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mi>ln</mi>
                            <mo>⁡</mo>
                            <mo stretchy="false">(</mo>
                            <mn>1</mn>
                            <mo>+</mo>
                            <mi>x</mi>
                            <mo stretchy="false">)</mo>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <msup>
                              <mi>f</mi>
                              <mo mathvariant="normal" lspace="0em" rspace="0em">′</mo>
                            </msup>
                            <mo stretchy="false">(</mo>
                            <mi>x</mi>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mfrac>
                              <mn>1</mn>
                              <mrow>
                                <mn>1</mn>
                                <mo>+</mo>
                                <mi>x</mi>
                              </mrow>
                            </mfrac>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <mi>f</mi>
                            <mtext>”</mtext>
                            <mo stretchy="false">(</mo>
                            <mi>x</mi>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mfrac>
                              <mrow>
                                <mo>−</mo>
                                <mn>1</mn>
                              </mrow>
                              <mrow>
                                <mo stretchy="false">(</mo>
                                <mn>1</mn>
                                <mo>+</mo>
                                <mi>x</mi>
                                <msup>
                                  <mo stretchy="false">)</mo>
                                  <mn>2</mn>
                                </msup>
                              </mrow>
                            </mfrac>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <mi>f</mi>
                            <msup>
                              <mtext>”</mtext>
                              <mo mathvariant="normal" lspace="0em" rspace="0em">′</mo>
                            </msup>
                            <mo stretchy="false">(</mo>
                            <mi>x</mi>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mfrac>
                              <mn>2</mn>
                              <mrow>
                                <mo stretchy="false">(</mo>
                                <mn>1</mn>
                                <mo>+</mo>
                                <mi>x</mi>
                                <msup>
                                  <mo stretchy="false">)</mo>
                                  <mn>3</mn>
                                </msup>
                              </mrow>
                            </mfrac>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <msup>
                              <mi>f</mi>
                              <mrow>
                                <mo stretchy="false">(</mo>
                                <mn>4</mn>
                                <mo stretchy="false">)</mo>
                              </mrow>
                            </msup>
                            <mo stretchy="false">(</mo>
                            <mi>x</mi>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mfrac>
                              <mrow>
                                <mo>−</mo>
                                <mn>3</mn>
                                <mo>⋅</mo>
                                <mn>2</mn>
                              </mrow>
                              <mrow>
                                <mo stretchy="false">(</mo>
                                <mn>1</mn>
                                <mo>+</mo>
                                <mi>x</mi>
                                <msup>
                                  <mo stretchy="false">)</mo>
                                  <mn>4</mn>
                                </msup>
                              </mrow>
                            </mfrac>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mi>
                            <mi mathvariant="normal">⋮</mi>
                            <mpadded height="+0em" voffset="0em">
                              <mspace mathbackground="black" width="0em" height="1.5em"></mspace>
                            </mpadded>
                          </mi>
                        </mstyle>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo fence="true">}</mo>
                </mrow>
                <mspace width="2em"></mspace>
                <mo>⟹</mo>
                <mspace width="2em"></mspace>
                <mrow>
                  <mo fence="true">{</mo>
                  <mtable rowspacing="0.1600em" columnalign="left" columnspacing="1em">
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <mi>f</mi>
                            <mo stretchy="false">(</mo>
                            <mn>0</mn>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mn>0</mn>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <msup>
                              <mi>f</mi>
                              <mo mathvariant="normal" lspace="0em" rspace="0em">′</mo>
                            </msup>
                            <mo stretchy="false">(</mo>
                            <mn>0</mn>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mn>1</mn>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <mi>f</mi>
                            <mtext>”</mtext>
                            <mo stretchy="false">(</mo>
                            <mn>0</mn>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mo>−</mo>
                            <mn>1</mn>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <mi>f</mi>
                            <msup>
                              <mtext>”</mtext>
                              <mo mathvariant="normal" lspace="0em" rspace="0em">′</mo>
                            </msup>
                            <mo stretchy="false">(</mo>
                            <mn>0</mn>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mn>2</mn>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mrow>
                            <msup>
                              <mi>f</mi>
                              <mrow>
                                <mo stretchy="false">(</mo>
                                <mn>4</mn>
                                <mo stretchy="false">)</mo>
                              </mrow>
                            </msup>
                            <mo stretchy="false">(</mo>
                            <mi>x</mi>
                            <mo stretchy="false">)</mo>
                            <mo>=</mo>
                            <mo>−</mo>
                            <mn>6</mn>
                          </mrow>
                        </mstyle>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mstyle scriptlevel="0" displaystyle="false">
                          <mi>
                            <mi mathvariant="normal">⋮</mi>
                            <mpadded height="+0em" voffset="0em">
                              <mspace mathbackground="black" width="0em" height="1.5em"></mspace>
                            </mpadded>
                          </mi>
                        </mstyle>
                      </mtd>
                    </mtr>
                  </mtable>
                </mrow>
              </mrow>
              <annotation encoding="application/x-tex"
                >\left.\begin{array}{l} f(x)=\ln(1+x)\\ f'(x)=\frac{1}{1+x}\\ f”(x)=\frac{-1}{(1+x)^2}\\
                f”'(x)=\frac{2}{(1+x)^3}\\ f^{(4)}(x)=\frac{-3\cdot 2}{(1+x)^4}\\ \vdots
                \end{array}\right\}\qquad\Longrightarrow\qquad \left\{ \begin{array}{l} f(0)=0\\ f'(0)=1\\ f”(0)=-1\\
                f”'(0)=2\\ f^{(4)}(x)=-6\\ \vdots \end{array} \right.
              </annotation>
            </semantics>
          </math>
        </span>
      </span>
    </span>
  </div>
  <div class="wp-block-katex-display-block katex-eq katex-rendered" data-katex-display="true">
    <span class="katex-display">
      <span class="katex">
        <span class="katex-mathml">
          <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
            <semantics>
              <mrow>
                <mi>ln</mi>
                <mo>⁡</mo>
                <mo stretchy="false">(</mo>
                <mn>1</mn>
                <mo>+</mo>
                <mi>x</mi>
                <mo stretchy="false">)</mo>
                <mo>=</mo>
                <mi>x</mi>
                <mo>−</mo>
                <mfrac>
                  <msup>
                    <mi>x</mi>
                    <mn>2</mn>
                  </msup>
                  <mn>2</mn>
                </mfrac>
                <mo>+</mo>
                <mfrac>
                  <msup>
                    <mi>x</mi>
                    <mn>3</mn>
                  </msup>
                  <mn>3</mn>
                </mfrac>
                <mo>−</mo>
                <mfrac>
                  <msup>
                    <mi>x</mi>
                    <mn>4</mn>
                  </msup>
                  <mn>4</mn>
                </mfrac>
                <mo>+</mo>
                <mo>…</mo>
                <mspace linebreak="newline"></mspace>
                <mo>=</mo>
                <munderover>
                  <mo>∑</mo>
                  <mrow>
                    <mi>k</mi>
                    <mo>=</mo>
                    <mn>0</mn>
                  </mrow>
                  <mi mathvariant="normal">∞</mi>
                </munderover>
                <mo stretchy="false">(</mo>
                <mo>−</mo>
                <mn>1</mn>
                <msup>
                  <mo stretchy="false">)</mo>
                  <mi>k</mi>
                </msup>
                <mfrac>
                  <msup>
                    <mi>x</mi>
                    <mrow>
                      <mi>k</mi>
                      <mo>+</mo>
                      <mn>1</mn>
                    </mrow>
                  </msup>
                  <mrow>
                    <mi>k</mi>
                    <mo>+</mo>
                    <mn>1</mn>
                  </mrow>
                </mfrac>
              </mrow>
              <annotation encoding="application/x-tex">
                \ln (1+x)=x-\frac{x^2}{2}+\frac{x^3}{3}-\frac{x^4}{4}+\ldots\\=\sum_{k=0}^\infty
                (-1)^k\frac{x^{k+1}}{k+1}</annotation
              >
            </semantics>
          </math>
        </span>
      </span>
    </span>
  </div>
  <script>
    // \left.\begin{array}{l} f(x)=\ln(1+x)\\ f'(x)=\frac{1}{1+x}\\ f”(x)=\frac{-1}{(1+x)^2}\\ f”'(x)=\frac{2}{(1+x)^3}\\ f^{(4)}(x)=\frac{-3\cdot 2}{(1+x)^4}\\ \vdots \end{array}\right\}\qquad\Longrightarrow\qquad \left\{ \begin{array}{l} f(0)=0\\ f'(0)=1\\ f”(0)=-1\\ f”'(0)=2\\ f^{(4)}(x)=-6\\ \vdots \end{array} \right.
    //	\ln (1+x)=x-\frac{x^2}{2}+\frac{x^3}{3}-\frac{x^4}{4}+\ldots\\=\sum_{k=0}^\infty (-1)^k\frac{x^{k+1}}{k+1}
  </script>
  <div style="height: 100px" aria-hidden="true" class="wp-block-spacer"></div>
  <p>For example, when f(x) so happens to be:</p>
  <div class="wp-block-katex-display-block katex-eq katex-rendered" data-katex-display="true">
    <span class="katex-display">
      <span class="katex">
        <span class="katex-mathml">
          <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
            <semantics>
              <mrow>
                <msup>
                  <mi>f</mi>
                  <mrow>
                    <mo stretchy="false">(</mo>
                    <mi>k</mi>
                    <mo stretchy="false">)</mo>
                  </mrow>
                </msup>
                <mo stretchy="false">(</mo>
                <mi>x</mi>
                <mo stretchy="false">)</mo>
                <mo>=</mo>
                <msup>
                  <mi>e</mi>
                  <mi>x</mi>
                </msup>
                <mspace width="1em"></mspace>
                <mo>⟹</mo>
                <mspace width="1em"></mspace>
                <msup>
                  <mi>f</mi>
                  <mrow>
                    <mo stretchy="false">(</mo>
                    <mi>k</mi>
                    <mo stretchy="false">)</mo>
                  </mrow>
                </msup>
                <mo stretchy="false">(</mo>
                <mn>0</mn>
                <mo stretchy="false">)</mo>
                <mo>=</mo>
                <mn>1.</mn>
              </mrow>
              <annotation encoding="application/x-tex"
                >f^{(k)}(x)=e^x \quad\Longrightarrow\quad f^{(k)}(0)=1.</annotation
              >
            </semantics>
          </math>
        </span>
      </span>
    </span>
  </div>
  <div class="wp-block-katex-display-block katex-eq katex-rendered" data-katex-display="true">
    <span class="katex-display">
      <span class="katex">
        <span class="katex-mathml">
          <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
            <semantics>
              <mrow>
                <msup>
                  <mi>e</mi>
                  <mi>x</mi>
                </msup>
                <mo>=</mo>
                <mn>1</mn>
                <mo>+</mo>
                <mi>x</mi>
                <mo>+</mo>
                <mfrac>
                  <msup>
                    <mi>x</mi>
                    <mn>2</mn>
                  </msup>
                  <mrow>
                    <mn>2</mn>
                    <mo stretchy="false">!</mo>
                  </mrow>
                </mfrac>
                <mo>+</mo>
                <mfrac>
                  <msup>
                    <mi>x</mi>
                    <mn>3</mn>
                  </msup>
                  <mrow>
                    <mn>3</mn>
                    <mo stretchy="false">!</mo>
                  </mrow>
                </mfrac>
                <mo>+</mo>
                <mo>…</mo>
                <mspace linebreak="newline"></mspace>
                <mo>=</mo>
                <munderover>
                  <mo>∑</mo>
                  <mrow>
                    <mi>k</mi>
                    <mo>=</mo>
                    <mn>0</mn>
                  </mrow>
                  <mi mathvariant="normal">∞</mi>
                </munderover>
                <mfrac>
                  <msup>
                    <mi>x</mi>
                    <mi>k</mi>
                  </msup>
                  <mrow>
                    <mi>k</mi>
                    <mo stretchy="false">!</mo>
                  </mrow>
                </mfrac>
              </mrow>
              <annotation encoding="application/x-tex">
                e^x=1+x+\frac{x^2}{2!} +\frac{x^3}{3!}+\ldots\\ =\sum_{k=0}^{\infty}\frac{x^k}{k!}</annotation
              >
            </semantics>
          </math>
        </span>
      </span>
    </span>
  </div>
  <div style="height: 100px" aria-hidden="true" class="wp-block-spacer"></div>
  <cite
    >So given the chance that your function written from the Taylor Series Formula contains
    <mark style="background-color: rgba(0, 0, 0, 0);color:purple;" class="has-inline-color has-vivid-purple-color">values</mark> from
    Taylor’s Theorems (as shown partially above), you then are able quickly simplify your function using the<mark
      style="background-color: rgba(0, 0, 0, 0); color: rgb(255, 0, 179);"
      class="has-inline-color has-pale-pink-color"
    >
      simplified values</mark
    >
    from said Theorem and avoiding a need of having to run complex math from your original, more complex
    <mark style="background-color: rgba(0, 0, 0, 0); color:purple" class="has-inline-color has-vivid-purple-color">values</mark>.
  </cite>
</blockquote>

`

const newMessageAdd=`
<p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px; font-family: carta-marina;"><br class="gmail-Apple-interchange-newline">And so as you can see from below, this is what is called a <span zeum4c5="PR_1_0" data-ddnwab="PR_1_0" aria-invalid="spelling" class="LI ng">psycian's</span> release to work form that is required by FMLA regulations to be provided to the employer whenever the employee returns to work from a Medical leave. THat's to say, It is against the law to return to work without proper validation and approval from a physician. Why would this be something that is required? Aetna, Let's pretend we are Kindergarten students learning about the importance of getting permission from the teacher before using the restroom or leaving the classroom. SO then why would a doctor in this case be required to then provide permission such that the employee can then leave the medical class of status and return back to a working class? Because Just like how a teacher has oversight and is required to meet a high level of standards as a provider, a doctor must ensure that a client is provided with a standard of care that is not at all influenced by any form of possible bias and hence the medical class is regarded as having priority over any other factors related to the clients livelihood. That is to also say, thereby allowing the working class to consist of employees that are medically provided and supported for such that the employer is able to take advantage of a working class of high performance or without <span zeum4c5="PR_2_0" data-ddnwab="PR_2_0" aria-invalid="grammar" class="Lm ng">hinderance</span> in performance due to environmental stressors outside of work.&nbsp;&nbsp;</p><p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px; font-family: carta-marina;"><br style="box-sizing: border-box; vertical-align: bottom;"></p><p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px; font-family: carta-marina;">So Aetna, let's take a look at the Behavioral Health Physician statement below. Note that this is the PHysician Statement that was provided to me by AMazon DLS for my FMLA from March 30th to June 11th of 2022. Note that at this point in time I have not at all been given any opportunity to provide a psychic statement to Amazon ERC. Instead, for the majority of the last year AMazon ERC has pretended to not understand how to read my writing, and as of right now, you are also doing the same thing Aetna.&nbsp;</p><p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px; font-family: carta-marina;">I'm not sure if this ongoing issue in intelligibility of my writing by my Employer as AWS or my health insurance provider such as Aetna, or the Attorney General of The State of Washington such as Bob Ferguson, perhaps occurs due to how I am someone with a foreign name, especially one that is spelled like ZIPING, and of course when you look at me you may also see that my skin color is green and hence implying that then it would be the case that English is a second language of mine and thus in writing english through a second language voice the written english produced is unintelligible or of highly ambitious grammatical oddities.&nbsp;</p><p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px;"><font face="carta-marina" style="box-sizing: border-box; vertical-align: bottom;">SO I am going to just make things explicit here and say that unfortunately, English is the second language I learned how to read and write, as well as form thoughts in. But that is to say, it is unfortunate because in terms of anything else related to a notion of what is being postured in the paragraph right above, there is none at all.&nbsp;</font></p><p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px;"><font face="carta-marina" style="box-sizing: border-box; vertical-align: bottom;"><br style="box-sizing: border-box; vertical-align: bottom;"></font></p><p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px;"><font face="carta-marina" style="box-sizing: border-box; vertical-align: bottom;">Therefore, I will state this bluntly but concisely so as to avoid appearing as a Bigot who worships himself: Any kind of position that attempts to identify my writing as something that hinders resolutions or prevents resolution from occurring is simply a form of admission that you do not have a valid argument defending it. It is an attempt to discredit my work and it should not be taken seriously. Further discussion of this matter is not necessary given the nature of my work evidenced..</font></p><p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px;"><font face="carta-marina" style="box-sizing: border-box; vertical-align: bottom;"><br style="box-sizing: border-box; vertical-align: bottom;"></font></p><p style="box-sizing: border-box; vertical-align: bottom; margin-top: 0px; margin-right: 0px; margin-left: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px;"><font face="carta-marina" style="box-sizing: border-box; vertical-align: bottom;">SO Aetna, As an added response required, I do not believe I had been released from medical leave by a provider and unfortunately instead of maintaining&nbsp;a high level of adherence to medical standards, you simply turned of my health insurance during my FMLA. Can you take action right now to activate my health insurance without further wasting my time?</font></p><p class="gmail-p3" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;; min-height: 12px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 3.8px 0px 0px 157.8px; color: rgb(31, 78, 121); font-size: 14px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;; text-align: center;">Behavioral Health Physician Statement</p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 3.2px 0px 0px 120.3px; color: rgb(28, 75, 120); font-size: 12px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span style="box-sizing: border-box; vertical-align: bottom; color: rgb(31, 78, 121); font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit;">This form needs to be completed by treating provider or treating provider office only&nbsp;</span><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 10px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal;">Fax to 1-855-579-1799 or by email to&nbsp;<a href="mailto:amazondls@amazon.com" style="box-sizing: border-box; vertical-align: bottom; color: rgb(17, 17, 204); text-decoration-line: none; background-color: initial; outline: none;"><span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(0, 0, 255); font-size: 16px; text-decoration-line: underline;">amazondls@amazon.com</span></a></span><br style="box-sizing: border-box; vertical-align: bottom;"></p><p class="gmail-p2" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 9.5px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><br style="box-sizing: border-box; vertical-align: bottom;"></p><p class="gmail-p3" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;"><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.1px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Patient</span></span><span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.6px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.1px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Name:</span></span><span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.6px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.1px;">Ziping</span><span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.6px;">&nbsp;</span><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.1px;">Liu</span></p><p class="gmail-p4" style="box-sizing: border-box; vertical-align: bottom; margin: 0.7px 0px 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Patient</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Job</span><span class="gmail-s4" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.4px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Title:</span><span class="gmail-s4" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.4px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span>Software<span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;">&nbsp;</span>Development<span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;">&nbsp;</span>Engineer<span class="gmail-s5" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.2px;">&nbsp;</span><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Requested</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Leave</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Start</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Date:</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span>March<span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;">&nbsp;</span>30,<span class="gmail-s4" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.4px;">&nbsp;</span>2022&nbsp;<span class="gmail-s5" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.2px;">&nbsp;</span><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Physical</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Demand:</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span>Regular<span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;">&nbsp;</span>Full<span class="gmail-s4" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.4px;">&nbsp;</span>Time</p><p class="gmail-p5" style="box-sizing: border-box; vertical-align: bottom; margin: 0.5px 0px 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; min-height: 11px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p><p class="gmail-p6" style="box-sizing: border-box; vertical-align: bottom; margin: 1.1px 0px 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;"><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Patient</span></span><span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.5px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Date</span></span><span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.5px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">of</span></span><span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.6px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Birth:</span></span><span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.5px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;">January</span><span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.5px;">&nbsp;</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;">28,</span><span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.5px;">&nbsp;</span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;">1995</span></p><p class="gmail-p4" style="box-sizing: border-box; vertical-align: bottom; margin: 0.7px 0px 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;"><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Case</span></span><span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.5px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Number:</span></span><span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.5px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.3px;">--04073256</span></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Helvetica;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700; font-family: Arial; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit;">Requested Return To Work:&nbsp;</span><span style="box-sizing: border-box; vertical-align: bottom; font-family: Arial; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit;">June 11, 2022</span></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Helvetica;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700; color: rgb(65, 65, 65); font-family: Arial; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit;"><br style="box-sizing: border-box; vertical-align: bottom;"></span></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Helvetica;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700; color: rgb(65, 65, 65); font-family: Arial; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit;">1. Diagnostic Information</span><br style="box-sizing: border-box; vertical-align: bottom;"></p><p class="gmail-p8" style="box-sizing: border-box; vertical-align: bottom; margin: 4.3px 0px 0px 5.5px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">Primary<span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.1px;">&nbsp;</span>Diagnosis:<span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.1px;">&nbsp;</span><span class="gmail-s9" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></span><span class="gmail-s10" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;">ICD-10:</span><span class="gmail-s11" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; letter-spacing: -0.6px;">&nbsp;</span><span class="gmail-s12" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; text-decoration-line: underline; letter-spacing: 4px;"><span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px;">&nbsp; &nbsp; &nbsp;&nbsp;</span></span><span class="gmail-s10" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;">Date</span><span class="gmail-s11" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; letter-spacing: -0.6px;">&nbsp;</span><span class="gmail-s10" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;">of</span><span class="gmail-s11" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; letter-spacing: -0.6px;">&nbsp;</span><span class="gmail-s10" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;">Onset:</span><span class="gmail-s11" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; letter-spacing: -0.6px;">&nbsp;</span><span class="gmail-s12" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; text-decoration-line: underline; letter-spacing: 4px;"><span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px;">&nbsp;&nbsp;</span></span><span class="gmail-s10" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;">/</span><span class="gmail-s12" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; text-decoration-line: underline; letter-spacing: 4px;"><span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px;">&nbsp;&nbsp;</span></span><span class="gmail-s10" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;">/</span><span class="gmail-s12" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px;">&nbsp;</span></span></p><p class="gmail-p9" style="box-sizing: border-box; vertical-align: bottom; margin: 3px 0px 0px 5.5px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">Secondary Diagnosis impacting work:<span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: -0.1px;">&nbsp;</span><span class="gmail-s9" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></span><span class="gmail-s10" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;">ICD-10:</span><span class="gmail-s13" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; letter-spacing: -0.5px;">&nbsp;</span><span class="gmail-s12" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; text-decoration-line: underline; letter-spacing: 4px;"><span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px;">&nbsp; &nbsp; &nbsp;</span></span></p><p class="gmail-p10" style="box-sizing: border-box; vertical-align: bottom; margin: 1.9px 0px 0px 5.5px; color: rgb(255, 0, 0); font-size: 11px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">Is the patient’s primary condition due to injury or illness arising out of the patient’s employment?<span class="gmail-s14" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: 3.9px;">&nbsp;&nbsp;</span><span class="gmail-s15" style="box-sizing: border-box; vertical-align: bottom; color: rgb(0, 0, 0); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></span><span class="gmail-s16" style="box-sizing: border-box; vertical-align: bottom; color: rgb(0, 0, 0); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; letter-spacing: 2px;">&nbsp;</span><span class="gmail-s17" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">No</span></span><span class="gmail-s18" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial; letter-spacing: 4px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">&nbsp;</span></span><span class="gmail-s15" style="box-sizing: border-box; vertical-align: bottom; color: rgb(0, 0, 0); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></span><span class="gmail-s19" style="box-sizing: border-box; vertical-align: bottom; color: rgb(0, 0, 0); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; letter-spacing: -0.4px;">&nbsp;</span><span class="gmail-s17" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">Yes</span></span></p><p class="gmail-p10" style="box-sizing: border-box; vertical-align: bottom; margin: 1.9px 0px 0px 5.5px; color: rgb(255, 0, 0); font-size: 11px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s17" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Arial;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;"><br style="box-sizing: border-box; vertical-align: bottom;"></span></span></p><p class="gmail-p6" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; min-height: 11px;"><font color="#000000" face="Arial" style="box-sizing: border-box; vertical-align: bottom;"><span style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 10px;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">12. Treatment Information</span></span></font></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Helvetica;"><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal;"><i style="box-sizing: border-box; vertical-align: bottom;">•&nbsp;</i></span><i style="box-sizing: border-box; vertical-align: bottom; font-size: 11px; font-variant-ligatures: inherit; font-variant-caps: inherit;">Office visits:</i><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal;"><i style="box-sizing: border-box; vertical-align: bottom;">&nbsp;</i></span><i style="box-sizing: border-box; vertical-align: bottom; font-variant-ligatures: inherit; font-variant-caps: inherit;">Most recent visit date: ____/____/_____ Next visit: ____/____/_____</i></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Helvetica;"><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal;"><i style="box-sizing: border-box; vertical-align: bottom;">• If Hospitalized,&nbsp;</i></span><i style="box-sizing: border-box; vertical-align: bottom;">Admitted on: _____/_____/_____ Discharged on: _____/_____/_____</i></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Helvetica;"><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal;"><i style="box-sizing: border-box; vertical-align: bottom;">• If Patient referred to specialist,&nbsp;</i></span><i style="box-sizing: border-box; vertical-align: bottom;">Providers Name_______________________ Specialty _________&nbsp;</i><i style="box-sizing: border-box; vertical-align: bottom; font-variant-ligatures: inherit; font-variant-caps: inherit;">Phone #__________</i></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal;"><font color="#000000" face="Helvetica" size="1" style="box-sizing: border-box; vertical-align: bottom;"><i style="box-sizing: border-box; vertical-align: bottom;"><span style="box-sizing: border-box; vertical-align: bottom; font-weight: 700;">13. Clinical and Functional Assessment<br style="box-sizing: border-box; vertical-align: bottom;"></span></i></font></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 1.5px 0px 0px 2px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">Do you consider your patient to be totally impaired from working?<span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: 4px;">&nbsp;</span><span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></span><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; letter-spacing: 2px;">&nbsp;</span>No<span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: 4px;">&nbsp;</span><span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></span><span class="gmail-s4" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span>Yes</p><p class="gmail-p3" style="box-sizing: border-box; vertical-align: bottom; margin: 0px 0px 0px 2px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">&nbsp; &nbsp;If yes, as of what date?<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px;">&nbsp;</span><span class="gmail-s5" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>/<span class="gmail-s5" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>/<span class="gmail-s5" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>,<span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; letter-spacing: 4px;">&nbsp;</span>with an actual / expected return to work date of<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px;">&nbsp;</span><span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 3.5px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>/<span class="gmail-s5" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>/<span class="gmail-s5" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;"><span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp; &nbsp;</span></span></p><p class="gmail-p3" style="box-sizing: border-box; vertical-align: bottom; margin: 0px 0px 0px 2px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">&nbsp; &nbsp;If yes, as supported by the following rationale based on patients most recent evaluation on&nbsp;<span class="gmail-s5" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;"><span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp; &nbsp; &nbsp;&nbsp;</span></span>(citing Mental Status Exam findings, patient’s functional impairments, your assessment).</p><p class="gmail-p17" style="box-sizing: border-box; vertical-align: bottom; margin: 0.3px 0px 0.1px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;; min-height: 11px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p><table cellspacing="0" cellpadding="0" class="gmail-t1" style="vertical-align: bottom; background-color: initial; border-collapse: collapse; border-spacing: 0px; width: 1004px;"><tbody style="box-sizing: border-box; vertical-align: bottom;"><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td1" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 1.5px 0.8px 0.8px 1px; border-color: rgb(0, 0, 0) rgb(0, 0, 0) rgb(127, 127, 127);"><p class="gmail-p18" style="box-sizing: border-box; vertical-align: bottom; margin: 5.9px 0px 0px 3.1px; color: rgb(65, 65, 65); font-size: 8px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">Date of Evaluation:</p></td><td valign="top" class="gmail-td2" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 1.5px 0.8px 0.8px; border-color: rgb(0, 0, 0) rgb(0, 0, 0) rgb(127, 127, 127);"><p class="gmail-p19" style="box-sizing: border-box; vertical-align: bottom; margin: 5.2px 0px 0px 5.2px; color: rgb(65, 65, 65); font-size: 8px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">Within Normal Limits</p></td><td valign="top" class="gmail-td2" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 1.5px 0.8px 0.8px; border-color: rgb(0, 0, 0) rgb(0, 0, 0) rgb(127, 127, 127);"><p class="gmail-p20" style="box-sizing: border-box; vertical-align: bottom; margin: 5.9px 0px 0px 9.6px; color: rgb(65, 65, 65); font-size: 8px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.1px;">Impaired</span></p></td><td valign="top" class="gmail-td3" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 1.5px 1px 0.8px 0.8px; border-color: rgb(0, 0, 0) rgb(0, 0, 0) rgb(127, 127, 127);"><p class="gmail-p21" style="box-sizing: border-box; vertical-align: bottom; margin: 7px 0px 0px 91.3px; color: rgb(65, 65, 65); font-size: 8px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">As Evidenced By:</p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td4" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 0.8px 1px 1px; border-color: rgb(127, 127, 127) rgb(0, 0, 0) rgb(0, 0, 0);"><p class="gmail-p22" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 1px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 1px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td><td valign="top" class="gmail-td5" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 0.8px 1px; border-color: rgb(127, 127, 127) rgb(0, 0, 0) rgb(0, 0, 0);"><p class="gmail-p22" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 1px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 1px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td><td valign="top" class="gmail-td6" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px; border-color: rgb(127, 127, 127) rgb(0, 0, 0) rgb(0, 0, 0);"><p class="gmail-p22" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 1px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 1px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td><td valign="top" class="gmail-td7" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 1px 1px 0.8px; border-color: rgb(127, 127, 127) rgb(0, 0, 0) rgb(0, 0, 0);"><p class="gmail-p22" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 1px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 1px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td8" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px 1px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p23" style="box-sizing: border-box; vertical-align: bottom; margin: 4.8px 0px 0px 5.8px; color: rgb(65, 65, 65); font-size: 8px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">A. General/Behavior Observations</p></td><td valign="top" class="gmail-td9" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p24" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td10" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 0.8px 0.8px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p24" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td11" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 1px 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p25" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 10px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td8" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px 1px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p23" style="box-sizing: border-box; vertical-align: bottom; margin: 4.8px 0px 0px 5.8px; color: rgb(65, 65, 65); font-size: 8px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">B. Language/Thought functioning</p></td><td valign="top" class="gmail-td9" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p24" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td9" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p24" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td11" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 1px 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p25" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 10px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td8" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px 1px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p26" style="box-sizing: border-box; vertical-align: bottom; margin: 4.8px 0px 0px 4.5px; color: rgb(65, 65, 65); font-size: 8px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">C. Emotional functioning (Mood/Affect)</p></td><td valign="top" class="gmail-td9" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p24" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td9" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p24" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td11" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 1px 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p25" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 10px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td8" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px 1px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p26" style="box-sizing: border-box; vertical-align: bottom; margin: 4.8px 0px 0px 4.5px; color: rgb(65, 65, 65); font-size: 8px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">D. Cognitive functioning</p></td><td valign="top" class="gmail-td9" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p24" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td9" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p24" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td11" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; background-color: rgb(241, 241, 241); border-style: solid; border-width: 1px 1px 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p25" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 10px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td12" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 1px 0.8px 0.8px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p27" style="box-sizing: border-box; vertical-align: bottom; margin: 4.8px 0px 0px 5.8px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">1.<span class="gmail-s8" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.5px;">&nbsp;</span>Focus/Attention/Memory</p></td><td valign="top" class="gmail-td13" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 1px 0.8px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p28" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td13" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 1px 0.8px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p28" style="box-sizing: border-box; vertical-align: bottom; margin: 3.6px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td14" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 1px 1px 0.8px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p25" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 10px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td15" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 0.8px 0.8px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p29" style="box-sizing: border-box; vertical-align: bottom; margin: 4.9px 0px 0px 5.8px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">2.<span class="gmail-s8" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.5px;">&nbsp;</span>Insight/Judgement/<span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.4px;">&nbsp;</span>Problem<span class="gmail-s25" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: 2px;">&nbsp;</span>Solving/Decision<span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.4px;">&nbsp;</span>making</p></td><td valign="top" class="gmail-td16" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p30" style="box-sizing: border-box; vertical-align: bottom; margin: 3.7px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td16" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p30" style="box-sizing: border-box; vertical-align: bottom; margin: 3.7px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td17" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 1px 0.8px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p25" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 10px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td18" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 0.8px 1px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p29" style="box-sizing: border-box; vertical-align: bottom; margin: 4.9px 0px 0px 5.8px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">3.<span class="gmail-s6" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.4px;">&nbsp;</span>Multitasking</p></td><td valign="top" class="gmail-td19" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 0.8px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p31" style="box-sizing: border-box; vertical-align: bottom; margin: 3.7px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td19" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 0.8px 1px; border-color: rgb(0, 0, 0);"><p class="gmail-p31" style="box-sizing: border-box; vertical-align: bottom; margin: 3.7px 0px 0px; color: rgb(68, 83, 106); font-size: 11px; padding: 0px; text-align: center; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></p></td><td valign="top" class="gmail-td20" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px 1px 1px 0.8px; border-color: rgb(0, 0, 0);"><p class="gmail-p25" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; min-height: 10px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p></td></tr></tbody></table><br style="box-sizing: border-box; vertical-align: bottom;"><br style="box-sizing: border-box; vertical-align: bottom;"><p class="gmail-p32" style="box-sizing: border-box; vertical-align: bottom; margin: 0px; color: rgb(65, 65, 65); font-size: 16px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; min-height: 13px;"><font color="#000000" face="Articulat CF" style="box-sizing: border-box; vertical-align: bottom;"><span style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px;">14. Return to Work Planning</span></font><br style="box-sizing: border-box; vertical-align: bottom;"></p><p class="gmail-p1" style="box-sizing: border-box; vertical-align: bottom; margin: 2.4px 0px 0px 2px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">What is the estimated date of the patient’s release to modified duty<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px;">&nbsp;</span><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 3.5px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>/<span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>/<span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>and to full duty<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px;">&nbsp;</span><span class="gmail-s1" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 3.5px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>/<span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;">&nbsp;<span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp;&nbsp;</span></span>/<span class="gmail-s2" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; text-decoration-line: underline; letter-spacing: 4px;"><span class="gmail-Apple-converted-space" style="box-sizing: border-box; vertical-align: bottom;">&nbsp; &nbsp;&nbsp;</span></span>Are there any</p><p class="gmail-p33" style="box-sizing: border-box; vertical-align: bottom; margin: 0px 0px 0px 6px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s40" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></span></p><p class="gmail-p2" style="box-sizing: border-box; vertical-align: bottom; margin: 1.9px 0px 0px 2px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">temporary work restrictions and/or accommodations which would allow your patient to return to work?</p><p class="gmail-p33" style="box-sizing: border-box; vertical-align: bottom; margin: 0px 0px 0px 6px; color: rgb(0, 0, 0); font-size: 9px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s40" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></span><span class="gmail-s41" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;; letter-spacing: 2px;">&nbsp;</span><span style="box-sizing: border-box; vertical-align: bottom; font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit;">No</span><span class="gmail-s34" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 16px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit; letter-spacing: 4px;">&nbsp;</span><span class="gmail-s40" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: Wingdings;"></span><span class="gmail-s42" style="box-sizing: border-box; vertical-align: bottom; color: rgb(65, 65, 65); font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span><span style="box-sizing: border-box; vertical-align: bottom; font-size: 11px; font-style: inherit; font-variant-ligatures: inherit; font-variant-caps: inherit;">Yes, If Yes please specify by providing objective quantification e.g. work for 6 hr/day for 4 weeks.</span><br style="box-sizing: border-box; vertical-align: bottom;"></p><p class="gmail-p35" style="box-sizing: border-box; vertical-align: bottom; margin: 0px 0px 0.1px; color: rgb(0, 0, 0); font-size: 10px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;; min-height: 12px;"><br style="box-sizing: border-box; vertical-align: bottom;"></p><table cellspacing="0" cellpadding="0" class="gmail-t1" style="vertical-align: bottom; background-color: initial; border-collapse: collapse; border-spacing: 0px; width: 1004px;"><tbody style="box-sizing: border-box; vertical-align: bottom;"><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td21" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.2px 0.8px 0.8px; border-color: rgb(0, 0, 0) rgb(191, 191, 191) rgb(0, 0, 0) rgb(0, 0, 0);"><p class="gmail-p36" style="box-sizing: border-box; vertical-align: bottom; margin: 2.7px 0px 0px 5.3px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;">Provider’s Name and Credentials (MD, DO, etc.)</p></td><td valign="top" class="gmail-td22" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.2px 0.8px 0.8px; border-color: rgb(0, 0, 0) rgb(191, 191, 191);"><p class="gmail-p37" style="box-sizing: border-box; vertical-align: bottom; margin: 2.7px 0px 0px 64.8px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.1px;">Specialty</span></p></td><td valign="top" class="gmail-td23" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.2px 0.8px 0.8px; border-color: rgb(0, 0, 0) rgb(0, 0, 0) rgb(0, 0, 0) rgb(191, 191, 191);"><p class="gmail-p38" style="box-sizing: border-box; vertical-align: bottom; margin: 2.7px 0px 0px 56.5px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.1px;">Date:</span></p></td></tr><tr style="box-sizing: border-box; vertical-align: bottom;"><td valign="top" class="gmail-td24" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px; border-color: rgb(0, 0, 0) rgb(191, 191, 191) rgb(191, 191, 191) rgb(0, 0, 0);"><p class="gmail-p39" style="box-sizing: border-box; vertical-align: bottom; margin: 2.6px 0px 0px 5.3px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.1px;">Signature</span></p></td><td valign="top" class="gmail-td25" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px; border-color: rgb(0, 0, 0) rgb(191, 191, 191) rgb(191, 191, 191);"><p class="gmail-p40" style="box-sizing: border-box; vertical-align: bottom; margin: 2.6px 0px 0px 65px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s3" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.1px;">Phone:</span></p></td><td valign="top" class="gmail-td26" style="box-sizing: border-box; vertical-align: bottom; padding: 0px 5px; border-style: solid; border-width: 0.8px; border-color: rgb(0, 0, 0) rgb(0, 0, 0) rgb(191, 191, 191) rgb(191, 191, 191);"><p class="gmail-p41" style="box-sizing: border-box; vertical-align: bottom; margin: 2.6px 0px 0px 57.8px; color: rgb(65, 65, 65); font-size: 7px; padding: 0px; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-kerning: auto; font-optical-sizing: auto; font-feature-settings: normal; font-variation-settings: normal; font-stretch: normal; line-height: normal; font-family: &quot;Articulat CF&quot;;"><span class="gmail-s7" style="box-sizing: border-box; vertical-align: bottom; font-size: 16px; letter-spacing: -0.2px;">Fax:</span></p></td></tr></tbody></table><br style="box-sizing: border-box; vertical-align: bottom;"><div style="box-sizing: border-box; vertical-align: bottom;"><br style="box-sizing: border-box; vertical-align: bottom;"></div><div style="box-sizing: border-box; vertical-align: bottom;"><br style="box-sizing: border-box; vertical-align: bottom; color: rgb(0, 0, 0); font-family: &quot;Open Sans&quot;; font-size: 14px;"></div>
`






export function clientId(){
    const host = window.location.hostname;
    
    if(host==='dev.githubliu.com'){
      return '118abf285ea14d3294a225655f44080c'
    } else if(host ==='aetnaliu.com'){
      return '70150ec42de74c59a2a891440ab426c8';
    }
    else if(host ==='aetnaliu-com.pages.dev'){
      return 'dd17b4c2235a4d46b44dd8ce575daf6d'
    }
    else {
      return 'b5f15800654443a7b4693a680e8387b0'
    }

}



export const SecureMessagesMapStyle = (props:any) => {



  const messageIndexes = [
    12,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
  ];
  const [replyStrValue, setReplyStrValue] = React.useState<string | null>(null);
  const [mapOfOpened, setMapOfOpened] = React.useState<Map<number, boolean>>(new Map());
  const [lastStrSizeStr, setLastStrSizeStr] = React.useState<number | null >(null);



  React.useEffect(() => {
    if(lastStrSizeStr !== replyStrValue?.length){

      setLastStrSizeStr(replyStrValue?.length || 0);

      console.log('brow ')


      
    }

  }, [replyStrValue, lastStrSizeStr])






  const [replyValue, setReplyValue] = React.useState<JSX.Element | null>( <>

    <div style={{ fontFamily: "articulat-cf" }}>
      <h2 style={{ fontFamily: "inherit" }}>
        <span
          style={{
            fontFamily: "ethnocentric",
            fontSize: "larger",
            fontWeight: 300,
          }}
        >
          So I have been rethinking this issue of Aetna seemingly clueless
          when it comes to actually realizing what has happened.
        </span>
      </h2>
    </div>
    <motion.a
      target="_blank"
      whileFocus={{ scale: 1.1, rotate: 90 }}
      whileHover={{ scale: 1.1, rotate: 90 }}
      whileTap={{ scale: 0.9 }}
      animate={{ scale: 1, rotate: [0, 90, 0] }}
      transition={{ duration: 1 }}
      onClick={(e) => {
        e.preventDefault();
        window.open(
          "https://awsuni.com/2023/03/lets-conclude-revisions-of-faith-stood-now-addendum-5-4-of-3/",
          "_blank"
        );
      }}
      rel="noopener noreferrer"
      // onhover="this.style.color='aqua'; this.style.textShadow='0px 0px 10px aqua; this.style.transform='rotate(-90deg)';this.style.filter='progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';"
      // onfocus="this.style.color='aqua'; this.style.textShadow='0px 0px 10px aqua'; this.style.transform='rotate(90deg)';;this.style.filter='progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';this.style.writing-mode='vertical-rl';"
      // onblur="this.style.color='aqua'; this.style.textShadow='0px 0px 10px aqua'; this.style.transform='rotate(0deg)';;this.style.filter='progid:DXImageTransform.Microsoft.BasicImage(rotation=0)';"
      // onmouseover="this.style.color='aqua'; this.style.textShadow='0px 0px 10px aqua'; this.style.transform='rotate(-270deg)';;this.style.filter='progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';"

      href="https://awsuni.com/2023/03/lets-conclude-revisions-of-faith-stood-now-addendum-5-4-of-3/"
      style={{
        color: "aqua",
        textShadow: "aqua 0px 0px 10px",
        transform: "rotate(-270deg)",
      }}
    >
      <p
        style={{
          fontFamily: "good-times",
          textAlign: "right",
          color: "limegreen",
        }}
      >
        I recall and look back to how I can logically make sense of this even
        clearly for you, almost as if a logically provided formulation...
      </p>
    </motion.a>
    <blockquote
      style={{
        textAlign: "left",
        fontFamily: "articulat-cf, sans-serif",
        lineHeight: "1.5",
        color: "#111",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "1em",
        borderLeft: "0.5px solid rgba(50, 205, 50, 0.832)",
        position: "relative",
        boxSizing: "border-box",
        width: "100%",
        marginLeft: "0.8rem",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        paddingTop: "1rem",
        paddingBottom: "1rem",
        background: "#f9f9f9",
        borderRadius: 0,
      }}
      className="wp-block-quote"
    >
      <p>
        You can then apply applicable
        <mark
          style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
          className="has-inline-color has-pale-pink-color"
        >
          lemmas, theorems, corollaries
        </mark>
        found within the properties seen in calculus to use within your
        function in order to quickly simplify your function formed.
      </p>
      <hr className="wp-block-separator has-alpha-channel-opacity" />
      <p>For example, when f(x) so happens to be:</p>
      <div
        className="wp-block-katex-display-block katex-eq katex-rendered"
        data-katex-display="true"
        style={{ fontFamily: "articulat-cf" }}
      >
        <span className="katex-display">
          <span className="katex">
            <span
              dangerouslySetInnerHTML={{
                __html: `  <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
                  <semantics>
                    <mrow>
                      <mrow>
                        <mtable
                          rowspacing="0.1600em"
                          columnalign="left"
                          columnspacing="1em"
                        >
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <mi>f</mi>
                                  <mo stretchy="false">(</mo>
                                  <mi>x</mi>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mi>ln</mi>
                                  <mo>⁡</mo>
                                  <mo stretchy="false">(</mo>
                                  <mn>1</mn>
                                  <mo>+</mo>
                                  <mi>x</mi>
                                  <mo stretchy="false">)</mo>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <msup>
                                    <mi>f</mi>
                                    <mo
                                      mathvariant="normal"
                                      lspace="0em"
                                      rspace="0em"
                                    >
                                      ′
                                    </mo>
                                  </msup>
                                  <mo stretchy="false">(</mo>
                                  <mi>x</mi>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mfrac>
                                    <mn>1</mn>
                                    <mrow>
                                      <mn>1</mn>
                                      <mo>+</mo>
                                      <mi>x</mi>
                                    </mrow>
                                  </mfrac>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <mi>f</mi>
                                  <mtext>”</mtext>
                                  <mo stretchy="false">(</mo>
                                  <mi>x</mi>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mfrac>
                                    <mrow>
                                      <mo>−</mo>
                                      <mn>1</mn>
                                    </mrow>
                                    <mrow>
                                      <mo stretchy="false">(</mo>
                                      <mn>1</mn>
                                      <mo>+</mo>
                                      <mi>x</mi>
                                      <msup>
                                        <mo stretchy="false">)</mo>
                                        <mn>2</mn>
                                      </msup>
                                    </mrow>
                                  </mfrac>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <mi>f</mi>
                                  <msup>
                                    <mtext>”</mtext>
                                    <mo
                                      mathvariant="normal"
                                      lspace="0em"
                                      rspace="0em"
                                    >
                                      ′
                                    </mo>
                                  </msup>
                                  <mo stretchy="false">(</mo>
                                  <mi>x</mi>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mfrac>
                                    <mn>2</mn>
                                    <mrow>
                                      <mo stretchy="false">(</mo>
                                      <mn>1</mn>
                                      <mo>+</mo>
                                      <mi>x</mi>
                                      <msup>
                                        <mo stretchy="false">)</mo>
                                        <mn>3</mn>
                                      </msup>
                                    </mrow>
                                  </mfrac>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <msup>
                                    <mi>f</mi>
                                    <mrow>
                                      <mo stretchy="false">(</mo>
                                      <mn>4</mn>
                                      <mo stretchy="false">)</mo>
                                    </mrow>
                                  </msup>
                                  <mo stretchy="false">(</mo>
                                  <mi>x</mi>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mfrac>
                                    <mrow>
                                      <mo>−</mo>
                                      <mn>3</mn>
                                      <mo>⋅</mo>
                                      <mn>2</mn>
                                    </mrow>
                                    <mrow>
                                      <mo stretchy="false">(</mo>
                                      <mn>1</mn>
                                      <mo>+</mo>
                                      <mi>x</mi>
                                      <msup>
                                        <mo stretchy="false">)</mo>
                                        <mn>4</mn>
                                      </msup>
                                    </mrow>
                                  </mfrac>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mi>
                                  <mi mathvariant="normal">⋮</mi>
                                  <mpadded height="+0em" voffset="0em">
                                    <mspace
                                      mathbackground="black"
                                      width="0em"
                                      height="1.5em"
                                    />
                                  </mpadded>
                                </mi>
                              </mstyle>
                            </mtd>
                          </mtr>
                        </mtable>
                        <mo fence="true">{"}"}</mo>
                      </mrow>
                      <mspace width="2em" />
                      <mo>⟹</mo>
                      <mspace width="2em" />
                      <mrow>
                        <mo fence="true">{"{"}</mo>
                        <mtable
                          rowspacing="0.1600em"
                          columnalign="left"
                          columnspacing="1em"
                        >
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <mi>f</mi>
                                  <mo stretchy="false">(</mo>
                                  <mn>0</mn>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mn>0</mn>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <msup>
                                    <mi>f</mi>
                                    <mo
                                      mathvariant="normal"
                                      lspace="0em"
                                      rspace="0em"
                                    >
                                      ′
                                    </mo>
                                  </msup>
                                  <mo stretchy="false">(</mo>
                                  <mn>0</mn>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mn>1</mn>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <mi>f</mi>
                                  <mtext>”</mtext>
                                  <mo stretchy="false">(</mo>
                                  <mn>0</mn>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mo>−</mo>
                                  <mn>1</mn>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <mi>f</mi>
                                  <msup>
                                    <mtext>”</mtext>
                                    <mo
                                      mathvariant="normal"
                                      lspace="0em"
                                      rspace="0em"
                                    >
                                      ′
                                    </mo>
                                  </msup>
                                  <mo stretchy="false">(</mo>
                                  <mn>0</mn>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mn>2</mn>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mrow>
                                  <msup>
                                    <mi>f</mi>
                                    <mrow>
                                      <mo stretchy="false">(</mo>
                                      <mn>4</mn>
                                      <mo stretchy="false">)</mo>
                                    </mrow>
                                  </msup>
                                  <mo stretchy="false">(</mo>
                                  <mi>x</mi>
                                  <mo stretchy="false">)</mo>
                                  <mo>=</mo>
                                  <mo>−</mo>
                                  <mn>6</mn>
                                </mrow>
                              </mstyle>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <mstyle scriptlevel={0} displaystyle="false">
                                <mi>
                                  <mi mathvariant="normal">⋮</mi>
                                  <mpadded height="+0em" voffset="0em">
                                    <mspace
                                      mathbackground="black"
                                      width="0em"
                                      height="1.5em"
                                    />
                                  </mpadded>
                                </mi>
                              </mstyle>
                            </mtd>
                          </mtr>
                        </mtable>
                      </mrow>
                    </mrow>
                    <annotation encoding="application/x-tex">
                      left.egin{"{"}array{"}"}
                      {"{"}l{"}"} f(x)=ln(1+x)\ f'(x)=rac{"{"}1{"}"}
                      {"{"}1+x{"}"}\ f”(x)=rac{"{"}-1{"}"}
                      {"{"}(1+x)^2{"}"}\ f”'(x)=rac{"{"}2{"}"}
                      {"{"}(1+x)^3{"}"}\ f^{"{"}(4){"}"}(x)=rac{"{"}-3cdot 2{"}"}
                      {"{"}(1+x)^4{"}"}\ dots end{"{"}array{"}"}
                      ight{"}"}qquadLongrightarrowqquad left{"{"} egin{"{"}array
                      {"}"}
                      {"{"}l{"}"} f(0)=0\ f'(0)=1\ f”(0)=-1\ f”'(0)=2\ f^{"{"}(4)
                      {"}"}(x)=-6\ dots end{"{"}array{"}"}
                      ight.
                    </annotation>
                  </semantics>
                </math>`,
              }}
              className="katex-mathml"
            ></span>
          </span>
        </span>
      </div>
      <div
        className="wp-block-katex-display-block katex-eq katex-rendered"
        data-katex-display="true"
      >
        <span className="katex-display">
          <span className="katex">
            <span
              dangerouslySetInnerHTML={{
                __html: `
                    <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
                    <semantics>
                      <mrow>
                        <mi>ln</mi>
                        <mo>⁡</mo>
                        <mo stretchy="false">(</mo>
                        <mn>1</mn>
                        <mo>+</mo>
                        <mi>x</mi>
                        <mo stretchy="false">)</mo>
                        <mo>=</mo>
                        <mi>x</mi>
                        <mo>−</mo>
                        <mfrac>
                          <msup>
                            <mi>x</mi>
                            <mn>2</mn>
                          </msup>
                          <mn>2</mn>
                        </mfrac>
                        <mo>+</mo>
                        <mfrac>
                          <msup>
                            <mi>x</mi>
                            <mn>3</mn>
                          </msup>
                          <mn>3</mn>
                        </mfrac>
                        <mo>−</mo>
                        <mfrac>
                          <msup>
                            <mi>x</mi>
                            <mn>4</mn>
                          </msup>
                          <mn>4</mn>
                        </mfrac>
                        <mo>+</mo>
                        <mo>…</mo>
                        <mspace linebreak="newline" />
                        <mo>=</mo>
                        <munderover>
                          <mo>∑</mo>
                          <mrow>
                            <mi>k</mi>
                            <mo>=</mo>
                            <mn>0</mn>
                          </mrow>
                          <mi mathvariant="normal">∞</mi>
                        </munderover>
                        <mo stretchy="false">(</mo>
                        <mo>−</mo>
                        <mn>1</mn>
                        <msup>
                          <mo stretchy="false">)</mo>
                          <mi>k</mi>
                        </msup>
                        <mfrac>
                          <msup>
                            <mi>x</mi>
                            <mrow>
                              <mi>k</mi>
                              <mo>+</mo>
                              <mn>1</mn>
                            </mrow>
                          </msup>
                          <mrow>
                            <mi>k</mi>
                            <mo>+</mo>
                            <mn>1</mn>
                          </mrow>
                        </mfrac>
                      </mrow>
                      <annotation encoding="application/x-tex">
                        ln (1+x)=x-rac{"{"}x^2{"}"}
                        {"{"}2{"}"}+rac{"{"}x^3{"}"}
                        {"{"}3{"}"}-rac{"{"}x^4{"}"}
                        {"{"}4{"}"}+ldots\=sum_{"{"}k=0{"}"}^infty (-1)^krac{"{"}x^
                        {"{"}k+1{"}"}
                        {"}"}
                        {"{"}k+1{"}"}
                      </annotation>
                    </semantics>
                  </math>
                  `,
              }}
              className="katex-mathml"
            ></span>
          </span>
        </span>
      </div>
      <div
        style={{ height: 100 }}
        aria-hidden="true"
        className="wp-block-spacer"
      />
      <p>For example, when f(x) so happens to be:</p>
      <div
        className="wp-block-katex-display-block katex-eq katex-rendered"
        data-katex-display="true"
      >
        <span className="katex-display">
          <span className="katex">
            <span
              dangerouslySetInnerHTML={{
                __html: `
                  <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
                  <semantics>
                    <mrow>
                      <msup>
                        <mi>f</mi>
                        <mrow>
                          <mo stretchy="false">(</mo>
                          <mi>k</mi>
                          <mo stretchy="false">)</mo>
                        </mrow>
                      </msup>
                      <mo stretchy="false">(</mo>
                      <mi>x</mi>
                      <mo stretchy="false">)</mo>
                      <mo>=</mo>
                      <msup>
                        <mi>e</mi>
                        <mi>x</mi>
                      </msup>
                      <mspace width="1em" />
                      <mo>⟹</mo>
                      <mspace width="1em" />
                      <msup>
                        <mi>f</mi>
                        <mrow>
                          <mo stretchy="false">(</mo>
                          <mi>k</mi>
                          <mo stretchy="false">)</mo>
                        </mrow>
                      </msup>
                      <mo stretchy="false">(</mo>
                      <mn>0</mn>
                      <mo stretchy="false">)</mo>
                      <mo>=</mo>
                      <mn>1.</mn>
                    </mrow>
                    <annotation encoding="application/x-tex">
                      f^{"{"}(k){"}"}(x)=e^x quadLongrightarrowquad f^{"{"}(k){"}"}
                      (0)=1.
                    </annotation>
                  </semantics>
                </math>
                  `,
              }}
              className="katex-mathml"
            ></span>
          </span>
        </span>
      </div>
      <div
        className="wp-block-katex-display-block katex-eq katex-rendered"
        data-katex-display="true"
      >
        <span className="katex-display">
          <span className="katex">
            <span
              dangerouslySetInnerHTML={{
                __html: `
                  <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
                  <semantics>
                    <mrow>
                      <msup>
                        <mi>e</mi>
                        <mi>x</mi>
                      </msup>
                      <mo>=</mo>
                      <mn>1</mn>
                      <mo>+</mo>
                      <mi>x</mi>
                      <mo>+</mo>
                      <mfrac>
                        <msup>
                          <mi>x</mi>
                          <mn>2</mn>
                        </msup>
                        <mrow>
                          <mn>2</mn>
                          <mo stretchy="false">!</mo>
                        </mrow>
                      </mfrac>
                      <mo>+</mo>
                      <mfrac>
                        <msup>
                          <mi>x</mi>
                          <mn>3</mn>
                        </msup>
                        <mrow>
                          <mn>3</mn>
                          <mo stretchy="false">!</mo>
                        </mrow>
                      </mfrac>
                      <mo>+</mo>
                      <mo>…</mo>
                      <mspace linebreak="newline" />
                      <mo>=</mo>
                      <munderover>
                        <mo>∑</mo>
                        <mrow>
                          <mi>k</mi>
                          <mo>=</mo>
                          <mn>0</mn>
                        </mrow>
                        <mi mathvariant="normal">∞</mi>
                      </munderover>
                      <mfrac>
                        <msup>
                          <mi>x</mi>
                          <mi>k</mi>
                        </msup>
                        <mrow>
                          <mi>k</mi>
                          <mo stretchy="false">!</mo>
                        </mrow>
                      </mfrac>
                    </mrow>
                    <annotation encoding="application/x-tex">
                      e^x=1+x+rac{"{"}x^2{"}"}
                      {"{"}2!{"}"} +rac{"{"}x^3{"}"}
                      {"{"}3!{"}"}+ldots\ =sum_{"{"}k=0{"}"}^{"{"}infty{"}"}rac{"{"}
                      x^k{"}"}
                      {"{"}k!{"}"}
                    </annotation>
                  </semantics>
                </math>
                  `,
              }}
              className="katex-mathml"
            ></span>
          </span>
        </span>
      </div>
      <div
        style={{ height: 100 }}
        aria-hidden="true"
        className="wp-block-spacer"
      />
      <cite>
        So given the chance that your function written from the Taylor Series
        Formula contains
        <mark
          style={{ backgroundColor: "rgba(0, 0, 0, 0)", color: "purple" }}
          className="has-inline-color has-vivid-purple-color"
        >
          values
        </mark>{" "}
        from Taylor’s Theorems (as shown partially above), you then are able
        quickly simplify your function using the
        <mark
          style={{
            backgroundColor: "rgba(0, 0, 0, 0)",
            color: "rgb(255, 0, 179)",
          }}
          className="has-inline-color has-pale-pink-color"
        >
          simplified values
        </mark>
        from said Theorem and avoiding a need of having to run complex math
        from your original, more complex
        <mark
          style={{ backgroundColor: "rgba(0, 0, 0, 0)", color: "purple" }}
          className="has-inline-color has-vivid-purple-color"
        >
          values
        </mark>
        .
      </cite>
    </blockquote>
    <p>
      I have also been understanding the consequences and effects of their
      ongoing actions. Aetna, I am now going to provide you with a more
      explicit explanation as your actions have lead to and are causing
      further damages. This explicit explanation is intended to give you a
      better understanding of what you have caused and are causing.
    </p>
    <h2>
      This explanation is therefore titled accordingly as
      <hr style={{ border: "1px solid rgba(0,0,0,0.95)" }} />
      <b style={{ fontFamily: "scotch-display" }}>
        June 4th Memorial Edition - Learning Series #1 with Aetna Support and
        i.
      </b>
    </h2>
    <cite style={{ textAlign: "right", display: "block" }}>
      <br />
      Without or with as little background or context as possible, let's just
      go right into a heart of a problem.
    </cite>
    <p style={{ fontFamily: "marigny", fontWeight: 500 }}>
      On the date in which you claimed that my insurance benefits ended,
      August 31st, 2022. The claims for that day can be found at{" "}
      <a
        // onclick="window.open('https://ziping.raped.by.adamselipsky.cn/x/d?c=32342436&l=ce25ed7c-fd94-4350-893c-91f1979e9f58&r=5418d38c-5c2a-4d7d-84c0-457a04289d48', '_blank');"
        href="https://ziping.raped.by.adamselipsky.cn/x/d?c=32342436&l=ce25ed7c-fd94-4350-893c-91f1979e9f58&r=5418d38c-5c2a-4d7d-84c0-457a04289d48"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          window.open(
            "https://ziping.raped.by.adamselipsky.cn/x/d?c=32342436&l=ce25ed7c-fd94-4350-893c-91f1979e9f58&r=5418d38c-5c2a-4d7d-84c0-457a04289d48",
            "_blank"
          );
        }}
        target="_blank"
        data-saferedirecturl="https://www.google.com/url?q=https://ziping.raped.by.adamselipsky.cn/x/d?c%3D32342436%26l%3Dce25ed7c-fd94-4350-893c-91f1979e9f58%26r%3D5418d38c-5c2a-4d7d-84c0-457a04289d48&source=gmail&ust=1686185397328000&usg=AOvVaw0-vhHOVqQbSUp6AUmkSrfP"
      >
        here
      </a>
      . It seems as though all of my health claims were denied after September
      1, 2022. I want to review the first claim denied in more detail. It
      would then be the claim from Maxwell on September 1st, as seen from this{" "}
      <a
        // onclick="window.open('https://aetnaliu.com/claims/manage/sep-1-2022-rebecca-maxwell-visit/', '_blank');"
        href="https://ziping.raped.by.adamselipsky.cn/x/d?c=32342436&l=0f8cb4f4-c062-4181-9341-58636658ffc5&r=5418d38c-5c2a-4d7d-84c0-457a04289d48"
        onClick={(e) => {
          e.preventDefault();
          window.open(
            "https://ziping.raped.by.adamselipsky.cn/x/d?c=32342436&l=0f8cb4f4-c062-4181-9341-58636658ffc5&r=5418d38c-5c2a-4d7d-84c0-457a04289d48",
            "_blank"
          );
        }}
        rel="noreferrer noopener"
        target="_blank"
        data-saferedirecturl="https://www.google.com/url?q=https://ziping.raped.by.adamselipsky.cn/x/d?c%3D32342436%26l%3D0f8cb4f4-c062-4181-9341-58636658ffc5%26r%3D5418d38c-5c2a-4d7d-84c0-457a04289d48&source=gmail&ust=1686185397328000&usg=AOvVaw38X0LplfD3GHz7q6ajuann"
      >
        link
      </a>
      . Upon viewing the more detailed claim denial reasoning, it is apparent
      that Aetna has written in remarks that they are not sure why the claim
      is denied. It is almost as if they have forgotten how to be a health
      insurer. I will just bring things to an explicit reality for you, Aetna.
    </p>
    <p style={{ fontFamily: "blanket", fontSize: "16pt" }}>
      <b
        style={{
          fontWeight: 700,
          fontFamily: "felt-tip-senior",
          fontSize: "larger",
        }}
      >
        Every day, I had been emailing you,
        <br />
      </b>{" "}
      and Amazon executives about what health services I am applying for with
      my insurance, keeping you informed of my progress. In the middle of my
      MaxWell TMS session, you decided to just forget and pretend that you had
      forgotten how to approve claims, since apparently Amazon legal
      instructed you to do so. Given that you keep using the excuse: "Because
      Amazon told us to" as reasons for this idiocy. Despite what people often
      think, my health is not a switch. It is not something that can be turned
      on and off. It is as if I am nothing more than a non-living
      manifestation of a non-living modality.
    </p>
    <p style={{ fontFamily: "carta-marina" }}>
      <strong style={{ fontSize: "larger" }}>
        Thus, such ways you treat me is ridiculous
      </strong>
      ,<br /> because at least a slave has a life, yet you think I am nothing,
      I am not even a slave. You are reasoning like a fool there because you
      treat me like nothing. You explain your actions in nonsensical terms,
      which is how you see me: something that doesn't make sense. As if I am
      some sort of{" "}
      <a
        href="https://ziping.raped.by.adamselipsky.cn/x/d?c=32342436&l=1bef5260-9a5b-4882-96dc-d9bb2c652dca&r=5418d38c-5c2a-4d7d-84c0-457a04289d48"
        // onclick="window.open('https://www.google.com/url?q=https://ziping.raped.by.adamselipsky.cn/x/d?c%3D32342436%26l%3D1bef5260-9a5b-4882-96dc-d9bb2c652dca%26r%3D5418d38c-5c2a-4d7d-84c0-457a04289d48&source=gmail&ust=1686185397328000&usg=AOvVaw2516D9AFzbrlQyJ4kmhg53', '_blank');"

        onClick={() => {
          window.open(
            "https://ziping.raped.by.adamselipsky.cn/x/d?c=32342436&l=1bef5260-9a5b-4882-96dc-d9bb2c652dca&r=5418d38c-5c2a-4d7d-84c0-457a04289d48",
            "_blank"
          );
        }}
        target="_blank"
        rel="noopener noreferrer"
        data-saferedirecturl="https://www.google.com/url?q=https://ziping.raped.by.adamselipsky.cn/x/d?c%3D32342436%26l%3D1bef5260-9a5b-4882-96dc-d9bb2c652dca%26r%3D5418d38c-5c2a-4d7d-84c0-457a04289d48&source=gmail&ust=1686185397328000&usg=AOvVaw2516D9AFzbrlQyJ4kmhg53"
      >
        allegory of a cave{" "}
      </a>
      in which my health is nothing more than your health codes, and
      itemizations, of health services on a sheet of paper... Because if I
      were something valuable to you, as a living thing, to say the least, you
      would not be responding to me this way in terms of how you have handled
      my messages sent because we are talking about my health here. Your
      responses demonstrate that you do not view me as a living being with
      feelings and concerns, but as an object of nonsensical existence which
      you can subject to your irrational reasoning. And so now be warned, you
      now know how stupendously atrocious this looks. I expect more clarity
      and resolve within 24 hours.
    </p>
    <p style={{ fontFamily: "carta-marina" }}>
      <br />
    </p>
    <p style={{ fontFamily: "carta-marina" }}>
      And so as you can see from below, this is what is called a psycian's
      release to work form that is required by FMLA regulations to be provided
      to the employer whenever the employee returns to work from a Medical
      leave. THat's to say, It is against the law to return to work without
      proper validation and approval from a physician. Why would this be
      something that is required? Aetna, Let's pretend we are Kindergarten
      students learning about the importance of getting permission from the
      teacher before using the restroom or leaving the classroom. SO then why
      would a doctor in this case be required to then provide permission such
      that the employee can then leave the medical class of status and return
      back to a working class? Because Just like how a teacher has oversight
      and is required to meet a high level of standards as a provider, a
      doctor must ensure that a client is provided with a standard of care
      that is not at all influenced by any form of possible bias and hence the
      medical class is regarded as having priority over any other factors
      related to the clients livelihood. That is to also say, thereby allowing
      the working class to consist of employees that are medically provided
      and supported for such that the employer is able to take advantage of a
      working class of high performance or without hinderance in performance
      due to environmental stressors outside of work.&nbsp;&nbsp;
    </p>
    <p style={{ fontFamily: "carta-marina" }}>
      <br />
    </p>
    <p style={{ fontFamily: "carta-marina" }}>
      So Aetna, let's take a look at the Behavioral Health Physician statement
      below. Note that this is the PHysician Statement that was provided to me
      by AMazon DLS for my FMLA from March 30th to June 11th of 2022. Note
      that at this point in time I have not at all been given any opportunity
      to provide a psychic statement to Amazon ERC. Instead, for the majority
      of the last year AMazon ERC has pretended to not understand how to read
      my writing, and as of right now, you are also doing the same thing
      Aetna.&nbsp;
    </p>
    <p style={{ fontFamily: "carta-marina" }}>
      I'm not sure if this ongoing issue in intelligibility of my writing by
      my Employer as AWS or my health insurance provider such as Aetna, or the
      Attorney General of The State of Washington such as Bob Ferguson,
      perhaps occurs due to how I am someone with a foreign name, especially
      one that is spelled like ZIPING, and of course when you look at me you
      may also see that my skin color is green and hence implying that then it
      would be the case that English is a second language of mine and thus in
      writing english through a second language voice the written english
      produced is unintelligible or of highly ambitious grammatical
      oddities.&nbsp;
    </p>
    <p style={{}}>
      SO I am going to just make things explicit here and say that
      unfortunately, English is the second language I learned how to read and
      write, as well as form thoughts in. But that is to say, it is
      unfortunate because in terms of anything else related to a notion of
      what is being postured in the paragraph right above, there is none at
      all.&nbsp;
    </p>
    <p style={{}}></p>
    <p style={{ fontFamily: "carta-marina" }}>
      Therefore, I will state this bluntly but concisely so as to avoid
      appearing as a Bigot who worships himself: Any kind of position that
      attempts to identify my writing as something that hinders resolutions or
      prevents resolution from occurring is simply a form of admission that
      you do not have a valid argument defending it. It is an attempt to
      discredit my work and it should not be taken seriously. Further
      discussion of this matter is not necessary given the nature of my work
      evidenced..
    </p>
    <p style={{}}></p>
    <p style={{}}>
      SO Aetna, As an added response required, I do not believe I had been
      released from medical leave by a provider and unfortunately instead of
      maintaining&nbsp;a high level of adherence to medical standards, you
      simply turned of my health insurance during my FMLA. Can you take action
      right now to activate my health insurance without further wasting my
      time?
    </p>
    <p
      className="p3"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        minHeight: 12,
        color: "rgb(0, 0, 0)",
      }}
    >
      <br />
    </p>
    <p
      className="p1"
      style={{
        marginTop: "3.8px",
        marginBottom: 0,
        marginLeft: "157.8px",
        color: "rgb(31, 78, 121)",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 14,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        textAlign: "center",
      }}
    >
      Behavioral Health Physician Statement
    </p>
    <p
      className="p1"
      style={{
        marginTop: "3.2px",
        marginBottom: 0,
        marginLeft: "120.3px",
        textAlign: "center",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 12,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(28, 75, 120)",
      }}
    >
      <span
        style={{
          color: "rgb(31, 78, 121)",
          fontSize: 11,
          textIndent: "-43.5px",
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        This form needs to be completed by treating provider or treating
        provider office only&nbsp;
      </span>
      <span
        className="s1"
        style={{
          textIndent: "-43.5px",
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
          fontSize: 10,
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          lineHeight: "normal",
        }}
      >
        Fax to 1-855-579-1799 or by email to&nbsp;
        <a href="mailto:amazondls@amazon.com">
          <span
            className="s2"
            style={{
              color: "rgb(0, 0, 255)",
              textDecorationLine: "underline",
            }}
          >
            amazondls@amazon.com
          </span>
        </a>
      </span>
      <br />
    </p>
    <p
      className="p2"
      style={{
        marginBottom: 0,
        color: "rgb(0, 0, 0)",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: "9.5px",
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
      }}
    >
      <br />
    </p>
    <p
      className="p3"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: "Arial",
        color: "rgb(0, 0, 0)",
      }}
    >
      <span className="s1" style={{ letterSpacing: "-0.1px" }}>
        <b>Patient</b>
      </span>
      <span className="s2" style={{ letterSpacing: "-0.6px" }}>
        <b> </b>
      </span>
      <span className="s1" style={{ letterSpacing: "-0.1px" }}>
        <b>Name:</b>
      </span>
      <span className="s2" style={{ letterSpacing: "-0.6px" }}>
        <b> </b>
      </span>
      <span className="s1" style={{ letterSpacing: "-0.1px" }}>
        Ziping
      </span>
      <span className="s2" style={{ letterSpacing: "-0.6px" }}>
        {" "}
      </span>
      <span className="s1" style={{ letterSpacing: "-0.1px" }}>
        Liu
      </span>
    </p>
    <p
      className="p4"
      style={{
        marginTop: "0.7px",
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: "Arial",
        color: "rgb(0, 0, 0)",
      }}
    >
      <b>Patient</b>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b> </b>
      </span>
      <b>Job</b>
      <span className="s4" style={{ letterSpacing: "-0.4px" }}>
        <b> </b>
      </span>
      <b>Title:</b>
      <span className="s4" style={{ letterSpacing: "-0.4px" }}>
        <b> </b>
      </span>
      Software
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        {" "}
      </span>
      Development
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        {" "}
      </span>
      Engineer
      <span className="s5" style={{ letterSpacing: "-0.2px" }}>
        {" "}
      </span>
      <b>Requested</b>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b> </b>
      </span>
      <b>Leave</b>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b> </b>
      </span>
      <b>Start</b>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b> </b>
      </span>
      <b>Date:</b>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b> </b>
      </span>
      March
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        {" "}
      </span>
      30,
      <span className="s4" style={{ letterSpacing: "-0.4px" }}>
        {" "}
      </span>
      2022&nbsp;
      <span className="s5" style={{ letterSpacing: "-0.2px" }}>
        {" "}
      </span>
      <b>Physical</b>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b> </b>
      </span>
      <b>Demand:</b>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b> </b>
      </span>
      Regular
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        {" "}
      </span>
      Full
      <span className="s4" style={{ letterSpacing: "-0.4px" }}>
        {" "}
      </span>
      Time
    </p>
    <p
      className="p5"
      style={{
        marginTop: "0.5px",
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: "Arial",
        minHeight: 11,
        color: "rgb(0, 0, 0)",
      }}
    >
      <br />
    </p>
    <p
      className="p6"
      style={{
        marginTop: "1.1px",
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: "Arial",
        color: "rgb(0, 0, 0)",
      }}
    >
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b>Patient</b>
      </span>
      <span className="s6" style={{ letterSpacing: "-0.5px" }}>
        <b> </b>
      </span>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b>Date</b>
      </span>
      <span className="s6" style={{ letterSpacing: "-0.5px" }}>
        <b> </b>
      </span>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b>of</b>
      </span>
      <span className="s2" style={{ letterSpacing: "-0.6px" }}>
        <b> </b>
      </span>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b>Birth:</b>
      </span>
      <span className="s6" style={{ letterSpacing: "-0.5px" }}>
        <b> </b>
      </span>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        January
      </span>
      <span className="s6" style={{ letterSpacing: "-0.5px" }}>
        {" "}
      </span>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        28,
      </span>
      <span className="s6" style={{ letterSpacing: "-0.5px" }}>
        {" "}
      </span>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        1995
      </span>
    </p>
    <p
      className="p4"
      style={{
        marginTop: "0.7px",
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: "Arial",
        color: "rgb(0, 0, 0)",
      }}
    >
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b>Case</b>
      </span>
      <span className="s6" style={{ letterSpacing: "-0.5px" }}>
        <b> </b>
      </span>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        <b>Number:</b>
      </span>
      <span className="s6" style={{ letterSpacing: "-0.5px" }}>
        <b> </b>
      </span>
      <span className="s3" style={{ letterSpacing: "-0.3px" }}>
        --04073256
      </span>
    </p>
    <p
      className="p1"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: "Helvetica",
        color: "rgb(0, 0, 0)",
      }}
    >
      <b
        style={{
          fontFamily: "Arial",
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        Requested Return To Work:{" "}
      </b>
      <span
        style={{
          color: "rgb(0, 0, 0)",
          fontFamily: "Arial",
          fontSize: 10,
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        June 11, 2022
      </span>
    </p>
    <p
      className="p1"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: "Helvetica",
        color: "rgb(0, 0, 0)",
      }}
    >
      <b
        style={{
          color: "rgb(65, 65, 65)",
          fontFamily: "Arial",
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        <br />
      </b>
    </p>
    <p
      className="p1"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: "Helvetica",
        color: "rgb(0, 0, 0)",
      }}
    >
      <b
        style={{
          color: "rgb(65, 65, 65)",
          fontFamily: "Arial",
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        1. Diagnostic Information
      </b>
      <br />
    </p>
    <p
      className="p8"
      style={{
        marginTop: "4.3px",
        marginBottom: 0,
        marginLeft: "5.5px",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      Primary
      <span className="s3" style={{ letterSpacing: "-0.1px" }}>
        {" "}
      </span>
      Diagnosis:
      <span className="s3" style={{ letterSpacing: "-0.1px" }}>
        &nbsp;
      </span>
      <span
        className="s9"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
        </span>
      </span>
      <span
        className="s10"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        ICD-10:
      </span>
      <span
        className="s11"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          letterSpacing: "-0.6px",
        }}
      >
        {" "}
      </span>
      <span
        className="s12"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          textDecorationLine: "underline",
          letterSpacing: 4,
        }}
      >
        <span className="Apple-converted-space">&nbsp; &nbsp; &nbsp; </span>
      </span>
      <span
        className="s10"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        Date
      </span>
      <span
        className="s11"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          letterSpacing: "-0.6px",
        }}
      >
        {" "}
      </span>
      <span
        className="s10"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        of
      </span>
      <span
        className="s11"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          letterSpacing: "-0.6px",
        }}
      >
        {" "}
      </span>
      <span
        className="s10"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        Onset:
      </span>
      <span
        className="s11"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          letterSpacing: "-0.6px",
        }}
      >
        {" "}
      </span>
      <span
        className="s12"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          textDecorationLine: "underline",
          letterSpacing: 4,
        }}
      >
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      <span
        className="s10"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        /
      </span>
      <span
        className="s12"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          textDecorationLine: "underline",
          letterSpacing: 4,
        }}
      >
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      <span
        className="s10"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        /
      </span>
      <span
        className="s12"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          textDecorationLine: "underline",
          letterSpacing: 4,
        }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp;</span>
      </span>
    </p>
    <p
      className="p9"
      style={{
        marginTop: 3,
        marginBottom: 0,
        marginLeft: "5.5px",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      Secondary Diagnosis impacting work:
      <span className="s3" style={{ letterSpacing: "-0.1px" }}>
        &nbsp;
      </span>
      <span
        className="s9"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
        </span>
      </span>
      <span
        className="s10"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        ICD-10:
      </span>
      <span
        className="s13"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          letterSpacing: "-0.5px",
        }}
      >
        {" "}
      </span>
      <span
        className="s12"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 10,
          lineHeight: "normal",
          fontFamily: "Arial",
          textDecorationLine: "underline",
          letterSpacing: 4,
        }}
      >
        <span className="Apple-converted-space">&nbsp; &nbsp; &nbsp;</span>
      </span>
    </p>
    <p
      className="p10"
      style={{
        marginTop: "1.9px",
        marginBottom: 0,
        marginLeft: "5.5px",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 11,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(255, 0, 0)",
      }}
    >
      Is the patient’s primary condition due to injury or illness arising out
      of the patient’s employment?
      <span className="s14" style={{ letterSpacing: "3.9px" }}>
        &nbsp;{" "}
      </span>
      <span
        className="s15"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
          fontFamily: "Wingdings",
          color: "rgb(0, 0, 0)",
        }}
      >
        
      </span>
      <span
        className="s16"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
          fontFamily: '"Times New Roman"',
          letterSpacing: 2,
          color: "rgb(0, 0, 0)",
        }}
      >
        {" "}
      </span>
      <span
        className="s17"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        <b>No</b>
      </span>
      <span
        className="s18"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
          fontFamily: "Arial",
          letterSpacing: 4,
        }}
      >
        <b> </b>
      </span>
      <span
        className="s15"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
          fontFamily: "Wingdings",
          color: "rgb(0, 0, 0)",
        }}
      >
        
      </span>
      <span
        className="s19"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
          fontFamily: '"Times New Roman"',
          letterSpacing: "-0.4px",
          color: "rgb(0, 0, 0)",
        }}
      >
        {" "}
      </span>
      <span
        className="s17"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
          fontFamily: "Arial",
        }}
      >
        <b>Yes</b>
      </span>
    </p>
    <p
      className="p10"
      style={{
        marginTop: "1.9px",
        marginBottom: 0,
        marginLeft: "5.5px",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        fontSize: 11,
        fontFamily: '"Articulat CF"',
        color: "rgb(255, 0, 0)",
      }}
    >
      <span
        className="s17"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          lineHeight: "normal",
          fontSize: 11,
          fontFamily: "Arial",
        }}
      >
        <b>
          <br />
        </b>
      </span>
    </p>
    <p
      className="p6"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        minHeight: 11,
      }}
    >
      <h2>
        <span style={{ fontSize: 10 }}>
          <b>12. Treatment Information</b>
        </span>
      </h2>
    </p>
    <p
      className="p1"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: "Helvetica",
        color: "rgb(0, 0, 0)",
      }}
    >
      <span
        className="s1"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
        }}
      >
        <i>•&nbsp;</i>
      </span>
      <i
        style={{
          fontSize: 11,
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        Office visits:
      </i>
      <span
        className="s1"
        style={{
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
        }}
      >
        <i>&nbsp;</i>
      </span>
      <i
        style={{
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        Most recent visit date: ____/____/_____ Next visit: ____/____/_____
      </i>
    </p>
    <p
      className="p1"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: "Helvetica",
        color: "rgb(0, 0, 0)",
      }}
    >
      <span
        className="s1"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
        }}
      >
        <i>• If Hospitalized, </i>
      </span>
      <i>Admitted on: _____/_____/_____ Discharged on: _____/_____/_____</i>
    </p>
    <p
      className="p1"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: "Helvetica",
        color: "rgb(0, 0, 0)",
      }}
    >
      <span
        className="s1"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 11,
          lineHeight: "normal",
        }}
      >
        <i>• If Patient referred to specialist, </i>
      </span>
      <i>Providers Name_______________________ Specialty _________&nbsp;</i>
      <i
        style={{
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        Phone #__________
      </i>
    </p>
    <p
      className="p1"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
      }}
    >
      <h2>
        <i>
          <b>
            13. Clinical and Functional Assessment
            <br />
          </b>
        </i>
      </h2>
    </p>
    <p
      className="p1"
      style={{
        marginTop: "1.5px",
        marginBottom: 0,
        marginLeft: 2,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      Do you consider your patient to be totally impaired from working?
      <span className="s1" style={{ letterSpacing: 4 }}>
        {" "}
      </span>
      <span
        className="s2"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 9,
          lineHeight: "normal",
          fontFamily: "Wingdings",
        }}
      >
        
      </span>
      <span
        className="s3"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 9,
          lineHeight: "normal",
          fontFamily: '"Times New Roman"',
          letterSpacing: 2,
        }}
      >
        {" "}
      </span>
      No
      <span className="s1" style={{ letterSpacing: 4 }}>
        {" "}
      </span>
      <span
        className="s2"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 9,
          lineHeight: "normal",
          fontFamily: "Wingdings",
        }}
      >
        
      </span>
      <span
        className="s4"
        style={{
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          fontSize: 9,
          lineHeight: "normal",
          fontFamily: '"Times New Roman"',
        }}
      >
        {" "}
      </span>
      Yes
    </p>
    <p
      className="p3"
      style={{
        marginBottom: 0,
        marginLeft: 2,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      &nbsp; &nbsp;If yes, as of what date?
      <span className="Apple-converted-space">&nbsp;</span>
      <span
        className="s5"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      /
      <span
        className="s5"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      /
      <span
        className="s5"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      ,
      <span className="s1" style={{ letterSpacing: 4 }}>
        {" "}
      </span>
      with an actual / expected return to work date of
      <span className="Apple-converted-space">&nbsp;</span>
      <span
        className="s6"
        style={{ textDecorationLine: "underline", letterSpacing: "3.5px" }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      /
      <span
        className="s5"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      /
      <span
        className="s5"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        <span className="Apple-converted-space">&nbsp; &nbsp;</span>
      </span>
    </p>
    <p
      className="p3"
      style={{
        marginBottom: 0,
        marginLeft: 2,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      &nbsp; &nbsp;If yes, as supported by the following rationale based on
      patients most recent evaluation on{" "}
      <span
        className="s5"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        <span className="Apple-converted-space">&nbsp; &nbsp; &nbsp; </span>
      </span>
      (citing Mental Status Exam findings, patient’s functional impairments,
      your assessment).
    </p>
    <p
      className="p17"
      style={{
        marginTop: "0.3px",
        marginBottom: "0.1px",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        minHeight: 11,
        color: "rgb(0, 0, 0)",
      }}
    >
      <br />
    </p>
    <table cellSpacing={0} cellPadding={0} className="t1">
      <tbody>
        <tr>
          <td
            valign="top"
            className="td1"
            style={{
              borderStyle: "solid",
              borderWidth: "1.5px 0.8px 0.8px 1px",
              borderColor: "rgb(0, 0, 0) rgb(0, 0, 0) rgb(127, 127, 127)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p18"
              style={{
                marginTop: "5.9px",
                marginLeft: "3.1px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 8,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              Date of Evaluation:
            </p>
          </td>
          <td
            valign="top"
            className="td2"
            style={{
              borderStyle: "solid",
              borderWidth: "1.5px 0.8px 0.8px",
              borderColor: "rgb(0, 0, 0) rgb(0, 0, 0) rgb(127, 127, 127)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p19"
              style={{
                marginTop: "5.2px",
                marginLeft: "5.2px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 8,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              Within Normal Limits
            </p>
          </td>
          <td
            valign="top"
            className="td2"
            style={{
              borderStyle: "solid",
              borderWidth: "1.5px 0.8px 0.8px",
              borderColor: "rgb(0, 0, 0) rgb(0, 0, 0) rgb(127, 127, 127)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p20"
              style={{
                marginTop: "5.9px",
                marginLeft: "9.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 8,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              <span className="s3" style={{ letterSpacing: "-0.1px" }}>
                Impaired
              </span>
            </p>
          </td>
          <td
            valign="top"
            className="td3"
            style={{
              borderStyle: "solid",
              borderWidth: "1.5px 1px 0.8px 0.8px",
              borderColor: "rgb(0, 0, 0) rgb(0, 0, 0) rgb(127, 127, 127)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p21"
              style={{
                marginTop: 7,
                marginLeft: "91.3px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 8,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              As Evidenced By:
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td4"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 0.8px 1px 1px",
              borderColor: "rgb(127, 127, 127) rgb(0, 0, 0) rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p22"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 1,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 1,
              }}
            >
              <br />
            </p>
          </td>
          <td
            valign="top"
            className="td5"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 0.8px 1px",
              borderColor: "rgb(127, 127, 127) rgb(0, 0, 0) rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p22"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 1,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 1,
              }}
            >
              <br />
            </p>
          </td>
          <td
            valign="top"
            className="td6"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px",
              borderColor: "rgb(127, 127, 127) rgb(0, 0, 0) rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p22"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 1,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 1,
              }}
            >
              <br />
            </p>
          </td>
          <td
            valign="top"
            className="td7"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 1px 1px 0.8px",
              borderColor: "rgb(127, 127, 127) rgb(0, 0, 0) rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p22"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 1,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 1,
              }}
            >
              <br />
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td8"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px 1px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p23"
              style={{
                marginTop: "4.8px",
                marginLeft: "5.8px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 8,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              A. General/Behavior Observations
            </p>
          </td>
          <td
            valign="top"
            className="td9"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p24"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td10"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "0.8px 0.8px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p24"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td11"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 1px 1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p25"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 9,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 10,
              }}
            >
              <br />
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td8"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px 1px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p23"
              style={{
                marginTop: "4.8px",
                marginLeft: "5.8px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 8,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              B. Language/Thought functioning
            </p>
          </td>
          <td
            valign="top"
            className="td9"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p24"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td9"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p24"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td11"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 1px 1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p25"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 9,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 10,
              }}
            >
              <br />
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td8"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px 1px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p26"
              style={{
                marginTop: "4.8px",
                marginLeft: "4.5px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 8,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              C. Emotional functioning (Mood/Affect)
            </p>
          </td>
          <td
            valign="top"
            className="td9"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p24"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td9"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p24"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td11"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 1px 1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p25"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 9,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 10,
              }}
            >
              <br />
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td8"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px 1px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p26"
              style={{
                marginTop: "4.8px",
                marginLeft: "4.5px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 8,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              D. Cognitive functioning
            </p>
          </td>
          <td
            valign="top"
            className="td9"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p24"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td9"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p24"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td11"
            style={{
              backgroundColor: "rgb(241, 241, 241)",
              borderStyle: "solid",
              borderWidth: "1px 1px 1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p25"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 9,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 10,
              }}
            >
              <br />
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td12"
            style={{
              borderStyle: "solid",
              borderWidth: "1px 0.8px 0.8px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p27"
              style={{
                marginTop: "4.8px",
                marginLeft: "5.8px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              1.
              <span className="s8" style={{ letterSpacing: "-0.5px" }}>
                {" "}
              </span>
              Focus/Attention/Memory
            </p>
          </td>
          <td
            valign="top"
            className="td13"
            style={{
              borderStyle: "solid",
              borderWidth: "1px 0.8px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p28"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td13"
            style={{
              borderStyle: "solid",
              borderWidth: "1px 0.8px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p28"
              style={{
                marginTop: "3.6px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td14"
            style={{
              borderStyle: "solid",
              borderWidth: "1px 1px 0.8px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p25"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 9,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 10,
              }}
            >
              <br />
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td15"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 0.8px 0.8px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p29"
              style={{
                marginTop: "4.9px",
                marginLeft: "5.8px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              2.
              <span className="s8" style={{ letterSpacing: "-0.5px" }}>
                {" "}
              </span>
              Insight/Judgement/
              <span className="s6" style={{ letterSpacing: "-0.4px" }}>
                {" "}
              </span>
              Problem
              <span className="s25" style={{ letterSpacing: 2 }}>
                {" "}
              </span>
              Solving/Decision
              <span className="s6" style={{ letterSpacing: "-0.4px" }}>
                {" "}
              </span>
              making
            </p>
          </td>
          <td
            valign="top"
            className="td16"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p30"
              style={{
                marginTop: "3.7px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td16"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p30"
              style={{
                marginTop: "3.7px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td17"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 1px 0.8px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p25"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 9,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 10,
              }}
            >
              <br />
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td18"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 0.8px 1px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p29"
              style={{
                marginTop: "4.9px",
                marginLeft: "5.8px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              3.
              <span className="s6" style={{ letterSpacing: "-0.4px" }}>
                {" "}
              </span>
              Multitasking
            </p>
          </td>
          <td
            valign="top"
            className="td19"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 0.8px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p31"
              style={{
                marginTop: "3.7px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td19"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 0.8px 1px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p31"
              style={{
                marginTop: "3.7px",
                textAlign: "center",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 11,
                lineHeight: "normal",
                fontFamily: "Wingdings",
                color: "rgb(68, 83, 106)",
              }}
            >
              
            </p>
          </td>
          <td
            valign="top"
            className="td20"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px 1px 1px 0.8px",
              borderColor: "rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p25"
              style={{
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 9,
                lineHeight: "normal",
                fontFamily: '"Times New Roman"',
                minHeight: 10,
              }}
            >
              <br />
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
    <p
      className="p32"
      style={{
        marginBottom: 0,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        minHeight: 13,
      }}
    >
      <span
        style={{ fontFamily: "Articulat-Cf", fontSize: 11, color: "#000000" }}
      >
        14. Return to Work Planning
      </span>

      <br />
    </p>
    <p
      className="p1"
      style={{
        marginTop: "2.4px",
        marginBottom: 0,
        marginLeft: 2,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      What is the estimated date of the patient’s release to modified duty
      <span className="Apple-converted-space">&nbsp;</span>
      <span
        className="s1"
        style={{ textDecorationLine: "underline", letterSpacing: "3.5px" }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      /
      <span
        className="s2"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      /
      <span
        className="s2"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      and to full duty<span className="Apple-converted-space">&nbsp;</span>
      <span
        className="s1"
        style={{ textDecorationLine: "underline", letterSpacing: "3.5px" }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      /
      <span
        className="s2"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        {" "}
        <span className="Apple-converted-space">&nbsp; </span>
      </span>
      /
      <span
        className="s2"
        style={{ textDecorationLine: "underline", letterSpacing: 4 }}
      >
        <span className="Apple-converted-space">&nbsp; &nbsp; </span>
      </span>
      Are there any
    </p>
    <p
      className="p33"
      style={{
        marginBottom: 0,
        marginLeft: 6,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        fontSize: 9,
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      <span
        className="s40"
        style={{
          fontSize: 11,
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          lineHeight: "normal",
          fontFamily: "Wingdings",
        }}
      />
    </p>
    <p
      className="p2"
      style={{
        marginTop: "1.9px",
        marginBottom: 0,
        marginLeft: 2,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 9,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      temporary work restrictions and/or accommodations which would allow your
      patient to return to work?
    </p>
    <p
      className="p33"
      style={{
        marginBottom: 0,
        marginLeft: 6,
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        fontSize: 9,
        fontFamily: '"Articulat CF"',
        color: "rgb(0, 0, 0)",
      }}
    >
      <span
        className="s40"
        style={{
          fontSize: 11,
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          lineHeight: "normal",
          fontFamily: "Wingdings",
        }}
      >
        
      </span>
      <span
        className="s41"
        style={{
          fontSize: 11,
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          lineHeight: "normal",
          fontFamily: '"Times New Roman"',
          letterSpacing: 2,
        }}
      >
        {" "}
      </span>
      <span
        style={{
          color: "rgb(0, 0, 0)",
          fontSize: 11,
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        No
      </span>
      <span
        className="s34"
        style={{
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
          letterSpacing: 4,
        }}
      >
        {" "}
      </span>
      <span
        className="s40"
        style={{
          fontSize: 11,
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          lineHeight: "normal",
          fontFamily: "Wingdings",
        }}
      >
        
      </span>
      <span
        className="s42"
        style={{
          fontSize: 11,
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          fontVariantAlternates: "normal",
          fontKerning: "auto",
          fontOpticalSizing: "auto",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          fontStretch: "normal",
          lineHeight: "normal",
          fontFamily: '"Times New Roman"',
        }}
      >
        {" "}
      </span>
      <span
        style={{
          color: "rgb(0, 0, 0)",
          fontSize: 11,
          fontStyle: "inherit",
          fontVariantLigatures: "inherit",
          fontVariantCaps: "inherit",
        }}
      >
        Yes, If Yes please specify by providing objective quantification e.g.
        work for 6 hr/day for 4 weeks.
      </span>
      <br />
    </p>
    <p
      className="p35"
      style={{
        marginBottom: "0.1px",
        fontVariantNumeric: "normal",
        fontVariantEastAsian: "normal",
        fontVariantAlternates: "normal",
        fontKerning: "auto",
        fontOpticalSizing: "auto",
        fontFeatureSettings: "normal",
        fontVariationSettings: "normal",
        fontStretch: "normal",
        fontSize: 10,
        lineHeight: "normal",
        fontFamily: '"Articulat CF"',
        minHeight: 12,
        color: "rgb(0, 0, 0)",
      }}
    >
      <br />
    </p>
    <table cellSpacing={0} cellPadding={0} className="t1">
      <tbody>
        <tr>
          <td
            valign="top"
            className="td21"
            style={{
              borderStyle: "solid",
              borderWidth: "0.2px 0.8px 0.8px",
              borderColor:
                "rgb(0, 0, 0) rgb(191, 191, 191) rgb(0, 0, 0) rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p36"
              style={{
                marginTop: "2.7px",
                marginLeft: "5.3px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              Provider’s Name and Credentials (MD, DO, etc.)
            </p>
          </td>
          <td
            valign="top"
            className="td22"
            style={{
              borderStyle: "solid",
              borderWidth: "0.2px 0.8px 0.8px",
              borderColor: "rgb(0, 0, 0) rgb(191, 191, 191)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p37"
              style={{
                marginTop: "2.7px",
                marginLeft: "64.8px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              <span className="s3" style={{ letterSpacing: "-0.1px" }}>
                Specialty
              </span>
            </p>
          </td>
          <td
            valign="top"
            className="td23"
            style={{
              borderStyle: "solid",
              borderWidth: "0.2px 0.8px 0.8px",
              borderColor:
                "rgb(0, 0, 0) rgb(0, 0, 0) rgb(0, 0, 0) rgb(191, 191, 191)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p38"
              style={{
                marginTop: "2.7px",
                marginLeft: "56.5px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              <span className="s3" style={{ letterSpacing: "-0.1px" }}>
                Date:
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td
            valign="top"
            className="td24"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px",
              borderColor:
                "rgb(0, 0, 0) rgb(191, 191, 191) rgb(191, 191, 191) rgb(0, 0, 0)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p39"
              style={{
                marginTop: "2.6px",
                marginLeft: "5.3px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              <span className="s3" style={{ letterSpacing: "-0.1px" }}>
                Signature
              </span>
            </p>
          </td>
          <td
            valign="top"
            className="td25"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px",
              borderColor:
                "rgb(0, 0, 0) rgb(191, 191, 191) rgb(191, 191, 191)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p40"
              style={{
                marginTop: "2.6px",
                marginLeft: 65,
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              <span className="s3" style={{ letterSpacing: "-0.1px" }}>
                Phone:
              </span>
            </p>
          </td>
          <td
            valign="top"
            className="td26"
            style={{
              borderStyle: "solid",
              borderWidth: "0.8px",
              borderColor:
                "rgb(0, 0, 0) rgb(0, 0, 0) rgb(191, 191, 191) rgb(191, 191, 191)",
              paddingRight: 5,
              paddingLeft: 5,
            }}
          >
            <p
              className="p41"
              style={{
                marginTop: "2.6px",
                marginLeft: "57.8px",
                fontVariantNumeric: "normal",
                fontVariantEastAsian: "normal",
                fontVariantAlternates: "normal",
                fontKerning: "auto",
                fontOpticalSizing: "auto",
                fontFeatureSettings: "normal",
                fontVariationSettings: "normal",
                fontStretch: "normal",
                fontSize: 7,
                lineHeight: "normal",
                fontFamily: '"Articulat CF"',
              }}
            >
              <span className="s7" style={{ letterSpacing: "-0.2px" }}>
                Fax:
              </span>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div>
      <br />
    </div>
    <div>
      <br />
    </div>
  </>

);

  const handleRowClick = (index:number) => {
    const mapOfOpenedCopy = new Map(mapOfOpened);
    mapOfOpenedCopy.set(index, !mapOfOpenedCopy.get(index));
    setMapOfOpened(mapOfOpenedCopy);
  }






  return(<>

    {
      messageIndexes.map((index:number) => {

        return(
          <div
          key = {
            index
          }
            className="panel panel-default securemail1"
            ng-repeat="msg in sentMsg | toArray | orderBy: sortingProName:reverseSorting"
          >
            <div className="row secureMail">
              <div className="panel-heading">
                <div className="row">
                  <div className="col-xs-12">
                    <div
                      className={
                          `col-xs-12 pad0  readMsg${mapOfOpened.get(index) ? ' activeMail' : ''}`
                      }
                      onClick={(e) => {
                          e.preventDefault()
                        
                          handleRowClick(index)
                      }}
  
  
                      ng-class="(changeIndex[$index])?'readMsg activeMail':'readMsg'"
                    >
                      <a
                        data-target="#5"
                        href=""
                        data-toggle="collapse"
                        data-parent="#securemailListbox3"
                        ng-attr-title="{{msg.isRead=='FALSE'?'unread Msg':''}}"
                        className="desktopmessageHide accordMail collapsed"
                        ng-click="getInboxDetails($index,msg.messageId);onClickShowFocus()"
                        ng-keypress="onEnterShowFocus($event)"
                        ng-class="(changeIndex[$index])?'accordMail':'accordMail collapsed'"
                        title=""
                      >
                        <div className="col-md-12 col-sm-12 col-xs-12  mail_contant">
                          <div className="col-xs-2 col-md-1 padL0">
                            <div className="mailArrow_indicator pull-left">
                              <span className="mailArrow_indicator_icon" />
                            </div>
                          </div>
                          <div
                            className="mailAttachment pull-left"
                            ng-class="{'hasAttachment':msg.hasAttachment =='true'}"
                          >
                            <span className="mailAttachment_icon" />
                          </div>
                          <div className="pull-left">
                            <span
                              className="mailRed_icon ng-hide"
                              ng-show="msg.subject =='Health Reminder message'"
                            />
                          </div>
                          <div className="col-md-8 col-xs-12">
                            <div className="padL2 pull-left">
                              <span
                                className="mail_icon"
                                ng-show="msg.subject !='Health Reminder message'"
                              />
                            </div>
                            <div className="col-md-9 col-xs-10 pull-left">
                              <p className="mail_subject">
                                Grievance - A complaint or appeal
                              </p>
                              <p className="mail_subject">

                                {
                                  getDate(
                                    index
                                  )
                                }


                              </p>
                            </div>
                          </div>
                        </div>
                      </a>
                      <a
                        data-target="#5"
                        href=""
                        data-toggle="collapse"
                        data-parent="#securemailListbox3"
                        ng-attr-title="{{msg.isRead=='FALSE'?'unread Msg':''}}"
                        className="mobilemessageHide accordMail collapsed"
                        ng-click="getInboxDetails($index,msg.messageId);onClickShowFocus()"
                        ng-keypress="onEnterShowFocus($event)"
                        ng-class="(changeIndex[$index])?'accordMail':'accordMail collapsed'"
                        title=""
                      >
                        <div className="col-md-12 col-sm-12 col-xs-12  mail_contant">
                          <div className="col-xs-1 col-md-1 padL0">
                            <div className="mailArrow_indicator pull-left">
                              <span className="mailArrow_indicator_icon" />
                            </div>
                          </div>
                          {/* <div class="mailAttachment hasAttachment pull-left"
                                          ng-if="msg.hasAttachment =='true'">
                                            <span class="mailAttachment_icon"></span>
                                          </div> */}
                          {/* <div class="pull-left">
                                            <span class="mailRed_icon" ng-show="msg.subject =='Health Reminder message'"></span>
                                          </div> */}
                          <div className="pull-left mail_contant">
                            {/**/}
                            <div className="pull-left">
                              {/**/}
                              {/**/}
                              <span
                                className="mail_icon"
                                ng-if="msg.subject !='Health Reminder message'"
                              />
                              {/**/}
                            </div>
                          </div>
                          <div className="mail_subject">
                            <div className="pull-left">
                              <p>Grievance - A complaint or appeal</p>
                              <p>Date received: 10/06/2022</p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
                            
                                        { mapOfOpened.get(index)        &&  JsxMessages({index,
                                        
                                          reply: replyValue,
                                          setReply: setReplyStrValue
                                        })}
                                
            </div>
          </div>
        )

      })
    }
  
  </>)
}